<template>
  <div>
    <v-medium-editor ref="mediumeditor" class="" @change="changed()" :prefill="processedContent" :options="options" />
	<vue-simple-context-menu
	  :elementId="'vueSimpleContextMenu'"
	  :options="contextMenu_options"
	  :ref="'vueSimpleContextMenu'"
	  @option-clicked="optionClicked"
	/>


	<!-- popup de edición de propiedades del elemento seleccionado -->
	<f7-popup ref="popupEdicion" class="popupedicion" v-if="popupEdicionShow" @popup:close="popupEdicionShow = false" :opened="true" swipeToClose>
		<f7-page>
			<f7-navbar>
			<f7-nav-left>
				<f7-link @click="applyChanges">Guardar</f7-link>
			</f7-nav-left>
			<f7-nav-title>Editar</f7-nav-title>
			<f7-nav-right></f7-nav-right>
			</f7-navbar>
			<!-- vamos a poner aquí el formulario de edición de propiedades del objeto seleccionado sacado de objetoActual -->
			<f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
				<f7-card-content>
					<f7-list strong-ios dividers-ios inset-ios>
						<div class="popup-title">Estilos
							<f7-link @click="addNewStyle" class="icon-button" title="Añadir nuevo estilo CSS">
								<i class="fa fa-plus"></i>
							</f7-link>
						</div>
						<f7-row>
							<f7-col width="50" v-for="(style, index) in objetoActual.properties.style" :key="'style-' + index">
								<div @contextmenu.prevent="showOptions(style, $event)" class="style-item">
									<f7-list-input 
										outline
										:label="index" 
										floating-label 
										type="text" 
										:placeholder="index" 
										clear-button
										@change="style.valor = $event.target.value"
										:value="style.valor"
									></f7-list-input>
								</div>
							</f7-col>
						</f7-row>
					</f7-list>
				</f7-card-content>
			</f7-card>
			<!-- vamos a poner aquí el formulario de edición de atributos del objeto seleccionado sacado de objetoActual -->
			<f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
				<f7-card-content>
					<f7-list strong-ios dividers-ios inset-ios>
						<div class="popup-title">Propiedades
							<f7-link @click="addNewAttribute" class="icon-button" title="Añadir nuevo atributo HTML">
								<i class="fa fa-plus"></i>
							</f7-link>
						</div>
						<f7-row>
							<f7-col width="50" v-for="(attribute, index) in objetoActual.properties.attributes" :key="'attribute-' + index">
								<div @contextmenu.prevent="showOptions(attribute, $event)" class="attribute-item">
									<f7-list-input 
										outline
										:label="index" 
										floating-label 
										type="text" 
										:placeholder="index" 
										clear-button
										@change="attribute.valor = $event.target.value"
										@contextmenu.prevent="showOptions(attribute, $event)"
										:value="attribute.valor"
									></f7-list-input>
								</div>
							</f7-col>
						</f7-row>
					</f7-list>
				</f7-card-content>
		  	</f7-card>
			<!-- Contenido del tag -->
			<f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
				<f7-card-content>
					<f7-list strong-ios dividers-ios inset-ios>
						<div class="popup-title">Contenido del Tag</div>
						<div style="margin-top: 10px; margin-left: 15px; margin-right: 15px;">
							<textarea 
								class="html-editor-textarea"
								placeholder="Edita el contenido HTML del tag seleccionado" 
								v-model="objetoActual.html"
								@change="objetoActual.html = $event.target.value"
							></textarea>
							<small style="color: #666; display: block; margin-top: 8px;">Edita el contenido HTML del tag seleccionado</small>
						</div>
					</f7-list>
				</f7-card-content>
			</f7-card>
			<!-- vamos a poner aquí el formulario de edición de atributos del objeto seleccionado sacado de objetoActual -->
			<f7-card v-if="objetoActual.properties.innerHTML" class="padding-vertical-half padding-right" style="z-index: 3000">
				<f7-card-content>
					<f7-list strong-ios dividers-ios inset-ios>
						<div class="popup-title">Contenido dinámico</div>
						<div style="margin-top: 5px; margin-left: 15px;" @contextmenu.prevent="showOptions(objetoActual.properties.innerHTML, $event)">
							<vue-editor
								ref="textareaContenidoDinamico"
								:placeholder="'Contenido dinámico'" 
								v-model="objetoActual.properties.innerHTML.valor"
								:editor-toolbar="customToolbar"
							></vue-editor>
							
						</div>
					</f7-list>
				</f7-card-content>
			</f7-card>
			<f7-popover 
				:closeByBackdropClick="false" 
				:backdrop="true" 
				closeOnEscape
				ref="popover"
			>
				<f7-navbar :title="$t('Selección de campos del elemento')">
					<f7-nav-right>
					</f7-nav-right>
				</f7-navbar>
				<f7-list no-hairlines-md>
					<select @change="setOptionSelected">
						<option>Seleccione un campo...</option>
						<option v-for="(opcion,index) in opciones" :key="'select.opcion-'+index" :value="opcion.content">{{ opcion.name }}</option>
					</select>
				</f7-list>
			</f7-popover>
		</f7-page>
		<!-- <div v-if="opciones">
			<select>
				<option></option>
				<option v-for="(opcion,index) in opciones" :key="'select.opcion-'+index" value="opcion.content">{{ opcion.name }}</option>
			</select>
		</div> -->
	</f7-popup>

  </div>
</template>
<style scoped>
	@import "~medium-editor/dist/css/medium-editor.css";
	@import "~vuejs-medium-editor/src/themes/default.css";
	@import "~font-awesome/css/font-awesome.css";
	/* @import "/path/to/node_modules/vue-simple-context-menu.css"; */
	/* @import "~medium-editor/dist/css/themes/bootstrap.css"; */
	@import '~highlight.js/styles/github.css';

	.vue-simple-context-menu__item {
		padding: 2px 0 2px 5px;
		color: #fff;
		cursor: pointer;
	}

	.icon-button {
		cursor: pointer;
		font-size: 18px;
		color: #007aff;
		float: right;
		margin-right: 10px;
		transition: all 0.2s ease;
	}

	.icon-button:hover {
		color: #0051d5;
		transform: scale(1.2);
	}

	.style-item,
	.attribute-item {
		display: flex;
		align-items: flex-start;
		gap: 8px;
	}

	.style-item ::v-deep .f7-list-input,
	.attribute-item ::v-deep .f7-list-input {
		flex: 1;
	}
</style>
<style>
	#vueSimpleContextMenu {
		position: fixed;
		background-color: #d4ceba !important;
		/* background-color: #23355b !important; */
		border: 1px solid #000000;
		color:#ffffff;
		border-radius: 0;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	}
	.medium-editor-toolbar {
	z-index: 50000;
	}
	.medium-editor-toolbar-form select{
	background-color: black;
	border: solid 2px white;
	}
	.medium-editor-toolbar-form .medium-editor-toolbar-input:focus, .medium-editor-toolbar-form label:focus {
		-webkit-appearance: auto !important; 
		-moz-appearance: auto !important;
		appearance: auto !important;
	}
	.medium-editor-toolbar-form input {
		border: 1px solid white;
		color: white;
		margin-left: 2px;
		border-radius: 5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	.valor,valor,caracteristica,caracteristicalistado,table.medium-editor-table {
		border: 1px dashed yellowgreen;
	}

	.valor::before,valor::before,caracteristica::before,caracteristicalistado::before {
		color: #bcbebc;
		content: '~';
	}
	table.medium-editor-table::before {
		color: #bcbebc;
		content: '~';
		position: absolute;
		left: 1.25cm;
		cursor: pointer;
		border: 1px solid #bcbebc;
	}
	.valor::after,valor::after,caracteristica::after,caracteristicalistado::after {
		color: #bcbebc;
		content: '~';
	}

	/* Solapas para tablas y filas */
	/* #page-container table {
		position: relative;
	} */

	/* #page-container table::after {
		content: '≡ TABLE';
		position: absolute;
		left: -45px;
		top: 0;
		width: 40px;
		height: 25px;
		background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
		color: white;
		border: 2px solid #2E7D32;
		border-radius: 4px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 9px;
		font-weight: bold;
		transition: all 0.2s ease;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
		user-select: none;
		pointer-events: all;
		z-index: 1000;
	}

	#page-container table::after:hover {
		background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
		transform: scale(1.05);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
	}

	#page-container tr {
		position: relative;
	}

	#page-container tr::before {
		content: '↔ ROW';
		position: absolute;
		left: -45px;
		top: 0;
		width: 40px;
		height: 25px;
		background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
		color: white;
		border: 2px solid #0D47A1;
		border-radius: 4px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 9px;
		font-weight: bold;
		transition: all 0.2s ease;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
		user-select: none;
		pointer-events: all;
		z-index: 1000;
	}

	#page-container tr::before:hover {
		background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
		transform: scale(1.05);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
	} */

	.popup-title {
		margin-left: 20px;
		font-weight: bold;
	}

	.html-editor-textarea {
		width: 100%;
		min-height: 250px;
		max-height: calc(40 * 1.6em + 24px);
		padding: 12px;
		border: 2px solid #ddd;
		border-radius: 6px;
		font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Courier New', monospace;
		font-size: 12px;
		line-height: 1.6;
		resize: vertical;
		background-color: #f8f9fa;
		color: #333;
		transition: all 0.3s ease;
		box-sizing: border-box;
		overflow-y: auto;
	}

	.html-editor-textarea:focus {
		outline: none;
		border-color: #007cba;
		background-color: #fff;
		box-shadow: 0 0 0 3px rgba(0, 124, 186, 0.1);
	}

	.html-editor-textarea::placeholder {
		color: #999;
	}
</style>
<script>

import VMediumEditor from 'vuejs-medium-editor'
import MediumEditor from 'medium-editor';
import Caracteristica from './extensions/Caracteristica'
import CaracteristicaListado from './extensions/CaracteristicaListado'
import Checkbox from './extensions/Checkbox'
import Watermark from './extensions/Watermark'
import Provisional from './extensions/Provisional'
import Cabecera from './extensions/Cabecera'
import Pie from './extensions/Pie'
import MediumEditorEnhacedTable from './extensions/MediumEditorEnhacedTable'
import ColorPicker from './extensions/Colorpicker'
import FontSize2 from './extensions/FontSize2'
import Bloque from './extensions/Bloque'
import ValorInspeccion from './extensions/ValorInspeccion'
import ValorEntidad from './extensions/ValorEntidad'
import SaltoPagina from './extensions/SaltoPagina'
import Combos from '../../js/db/Combos'
import Inspeccion from '../../js/db/Inspeccion'
import LineaPedido from '../../js/db/LineaPedido.js'
import Oferta from '../../js/db/Oferta.js'
import Oportunidad from '../../js/db/Oportunidad.js'
import Factura from '../../js/db/Factura.js'
import VueEditor from "../vue2-editor/VueEditor.vue"

import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import VueSimpleContextMenu from "vue-simple-context-menu";
import Tarea from '../../js/db/Tarea';

export default {
  components: {
    VMediumEditor,
	VueSimpleContextMenu,
	VueEditor
  },
  data() {
    return {
	  self: this,
	  item: null,
	  nPaginas: 1,
	  bloques: {b1:[],b2:[]},
	  // Configuración de márgenes (en cm)
	  pageMargins: {
		top: 3.5,
		right: 1.5,
		bottom: 1,
		left: 1.5
	  },
	  htmlData: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN" "http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
\${head}
\${body}
</html>`,
	  headMail: `<head>
<meta content="text/html;charset=utf-8" http-equiv="content-type" />
<style type="text/css">
body {
	margin: 0;
	font-size: 80%;
}
#page-container {
	width: auto;
	height: auto;
	overflow: visible;
 	background-color: rgb(82, 86, 89);
	position: relative;
	margin: 0;
	border: 0;	
	font-family: sans-serif;
	letter-spacing: -0.6px;
	padding: 0;
}
.pf {
	position: relative;
	background-image: linear-gradient(0deg, white 49.95%, grey 49.95%, grey 50%, white 50%, white 99.95%, grey 99.95%, grey 100%);
	background-size: 1790px 1790px;
	background-repeat: repeat;
	border: 0;
	margin: 0 auto;
	box-shadow: 1px 1px 3px 1px #333;
	border-collapse: collapse;
	width:21.1cm;
	min-height:23.7cm;
	padding: 1cm 1.5cm;
	z-index: 10000;
	background-color: white;
}
</style>
</head>`,
	  head: `<head>
<meta content="text/html;charset=utf-8" http-equiv="content-type" />
<title>FICHERO</title>
<style type="text/css">
@charset "UTF-8";
@page {
	/* portrait|landscape */
	size: A4 portrait;
	/* set page margins superior derecho inferior izquierdo*/
	/*PAGE-MARGIN-START*/margin: 3.5cm 1.5cm 1cm 1.5cm;/*PAGE-MARGIN-END*/
	/* Default header */
	@top-center{ content: element(pageHeader); }
	/* Default footers */
	@bottom-center{ content: element(pageFooter); }
}
@page watermarked{
	background: url('${process.env.SERVER_UPLOADS_DIR}/static/img/watermark.png') no-repeat center;
	background-size: 21.5cm 30cm;
}
@page provisional{
	background: url('${process.env.SERVER_UPLOADS_DIR}/static/img/provisional.png') no-repeat center;
	background-size: 21.5cm 30cm;
}
@page provisionalWatermarked{
	background: url('${process.env.SERVER_UPLOADS_DIR}/static/img/provisional-watermark.png') no-repeat center;
	background-size: 21.5cm 30cm;
}
@page borrador{
	background: url('${process.env.SERVER_UPLOADS_DIR}/static/img/borrador.png') no-repeat center;
	background-size: 21.5cm 30cm;
}
@page borradorWatermarked{
	background: url('${process.env.SERVER_UPLOADS_DIR}/static/img/borrador-watermark.png') no-repeat center;
	background-size: 21.5cm 30cm;
}

body {
	margin: 0;
	font-size: 80%;
	-webkit-print-color-adjust: exact;
}
body.watermarked{
	page: watermarked;
}
body.provisional{
	page: provisional;
}
body.watermarked.provisional{
	page: provisionalWatermarked;
}
body.borrador{
	page: borrador;
}
body.watermarked.borrador{
	page: borradorWatermarked;
}

/* Indicador visual de márgenes - posición centrada */
#page-container::after {
	content: "📐";
	position: fixed;
	top: 33%;
	left: 20%;
	background: rgba(255, 255, 255, 0.9);
	border: 2px solid #007cba;
	border-radius: 50%;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	cursor: pointer;
	z-index: 10000;
	transition: all 0.3s ease;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	user-select: none;
	pointer-events: all;
}

#page-container::after:hover {
	background: #007cba;
	color: white;
	transform: scale(1.1);
	box-shadow: 0 4px 12px rgba(0, 124, 186, 0.3);
}
.medium-editor-container {
	background: rgb(82, 86, 89);
	padding-top: 50px !important;
}
#editor-container {
	padding-top: 0;
	position: relative;
	display: flex;
	flex-direction: column;
	min-height: calc(100vh - 50px);
}
#pageHeader{ 
	padding-top: 1.5cm; 
	width: 100%; 
	position: relative; 
}

#header-container {
	position: sticky;
	top: 0;
	width: auto;
	height: auto;
	overflow: visible;
	margin: 0;
	padding: 0;
	border: 0;
	font-family: sans-serif;
	letter-spacing: -0.6px;
	z-index: 100;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
#header-container.no-header {
  display:none;
}

/* Estilos para divisiones de página visibles solo en editor */
.page-break {
	border-bottom: 2px dashed #007cba;
	margin: 0;
	padding: 0;
	height: 2px;
	position: relative;
	background: rgba(0, 124, 186, 0.1);
}

.page-break::after {
	content: "Página " counter(page-counter);
	counter-increment: page-counter;
	position: absolute;
	right: 10px;
	top: -10px;
	background: #007cba;
	color: white;
	padding: 2px 8px;
	font-size: 10px;
	border-radius: 3px;
	z-index: 10;
}

body {
	counter-reset: page-counter;
}

#pageFooter:before {
	content: "Pag. " counter(page) " de " counter(pages);
	position: absolute;
	bottom: 0.5cm;
	left: 0;
	font-size: 8px;
}
#pageFooter:after {
	content: /*INICIO-NOMBRE-FICHERO*//*FIN-NOMBRE-FICHERO*/;
	position: absolute;
	bottom: 0.5cm;
	right: 0;
	font-size: 8px;
}
#pageFooter:before, #pageFooter:after{ display:none;}
#pageFooter.no-footer{
	display:none;
}

.hf {
	position: relative;
    background-size: 43.2px;
	background-color: white;
	overflow: hidden;
	border: 0;
	margin: 0 auto;
	padding: 0 1.5cm; 
	box-shadow: 1px 1px 3px 1px #333;
	border-collapse: collapse;
	width:21.1cm;
}

#page-container {
	width: auto;
	height: auto;
	overflow: visible;
	position: relative;
	margin: 0;
	border: 0;	
	font-family: sans-serif;
	letter-spacing: -0.6px;
	padding: 0;
}
#header-container.no-header + #page-container {
	top: 0;
	padding-top: 1.5cm;
}

/* Estilo para simular páginas A4 en el editor */
.page-simulation {
	min-height: 21cm; /* Altura aproximada de página A4 menos márgenes */
	margin-bottom: 1cm;
	position: relative;
}

.page-simulation:not(:last-child)::after {
	content: '';
	position: absolute;
	bottom: -0.5cm;
	left: 0;
	right: 0;
	height: 2px;
	background: linear-gradient(90deg, #007cba 0%, #007cba 50%, transparent 50%, transparent 100%);
	background-size: 10px 2px;
}


.pf {
	position: relative;
	background-image: linear-gradient(0deg, white 49.95%, grey 49.95%, grey 50%, white 50%, white 99.95%, grey 99.95%, grey 100%);
	background-size: 1790px 1790px;
	background-repeat: repeat;
	border: 0;
	margin: 0 auto;
	box-shadow: 1px 1px 3px 1px #333;
	border-collapse: collapse;
	width:21.1cm;
	min-height:23.7cm;
	padding: 1cm 1.5cm;
	z-index: 10000;
}
.pf.watermarked {
	background: url('static/img/watermark.png') no-repeat center 5cm / 47em, linear-gradient(0deg, white 49.95%, grey 49.95%, grey 50%, white 50%, white 99.95%, grey 99.95%, grey 100%) top /1790px 1790px;
}
#pageFooter {
	position: sticky;
	bottom: 0;
	background: white;
	border: 0;
	margin: 0 auto;
	box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
	width:21.1cm;
	padding: 0.5cm 1.5cm;
	z-index: 100;
}


.encabezado {
	margin: 0; 
 	padding: 0; 
	text-align: center;
	position: relative;
}
.encabezado.encabezado-2 {
    margin: 1em 0;
}
.encabezado-ENAC .logo-ENAC {
	position: absolute;
	right: 0;
	top: 0;
}
.encabezado-ENAC .logo-ENAC.logo-ENAC-2 {
    top: -2em;
}
.encabezado-ENAC .fs7.num-cenac {
	position: relative;
	bottom: 1.6em;
	text-align: center;
	font-size: 11px !important;
}

.cod-expediente {
    text-align: right;
}
.cod-expediente span.code {
    display: inline-block;
    width: 180pt;
    border: 1px solid black;
    padding: 0.1em 0.5em;
    margin-left: 1em;
	white-space: nowrap;
}

div.cuerpo {
}

p {margin-left: 0; text-align: justify;}
table {border-collapse: collapse; table-layout: fixed;}

tbody tr td {
	border: 0;
	margin: 3px;
}

thead tr th.cabecera1, thead tr th.cabecera1_left {
	vertical-align: middle;
	text-align: center;
	padding: 10px;
}

thead tr th.cabecera1_left {
	text-align: left;
}

thead.cabecera2 tr {
	padding: 10px;
}

thead.cabecera2 tr th {
	vertical-align: middle;
	text-align: left;
	border: 0;
}

.titulo {margin-bottom: 1em;}

.tab-1 {display:inline-block; width: 2.5em;}
.tab-2 {display:inline-block; width: 5em;}
.medium-editor-toolbar-colorpicker {
	display: inline-block;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	border: 1px solid white;
	margin: -2px;
}
.medium-editor-container * {
	font-size: 0.8rem;
}
.medium-editor-table.medium-editor-table-selected >*>*> td{
	border-color: goldenrod !important;
}
.medium-editor-table {
	page-break-inside: avoid;
	table-layout: fixed;
}
.medium-editor-table, .medium-editor-table td p{
	margin: 0;
	padding: 0;
}
.medium-editor-table.show-borders >*>*>td {
  border: 1px solid black;
}
.medium-editor-table:not(.show-borders) >*>*>td {
  border: 1px dashed #e3e3e3;
}
.medium-editor-table:not(.show-borders), .medium-editor-table:not(.show-borders)&gt;tbody&gt;tr&gt;td, .medium-editor-table:not(.show-borders)&gt;thead&gt;tr&gt;td {
  /* border: 1px dashed #e3e3e3; */
}
img {
    max-width: 100%;
}
table thead.workaround-cell-size tr, table thead.workaround-cell-size tr td {
    height: 0px !important;
    line-height: 0;
    padding: 0;
    margin: 0;
	border: 0;
	visibility: hidden;
}
table.medium-editor-table tr {height:1px;}
table.medium-editor-table tr td {height:inherit;}
table tbody td .cell-content {
	background: rgba(255,0,0,0.5) !important;
	height: 100%;
}

.custom-fc { font-size: inherit; }
.custom-fs.fs-xxs{ font-size: 8px !important; }
.custom-fs.fs-xs{ font-size: 10px !important; }
.custom-fs.fs-s{ font-size: 12px !important; }
.custom-fs.fs-n{ font-size: 14px !important; }
.custom-fs.fs-l{ font-size: 16px !important; }
.custom-fs.fs-xl{ font-size: 18px !important; }
.custom-fs.fs-xxl{ font-size: 20px !important; }

.firma{
    display: block;
    width: 225px;
    height: 90px;
    font-size: 1pt !important;
    color: white;
    border: 1px solid grey;
}
.salto-pagina {
	display: block;
}

img[src*="cid:"]{
  max-width: 100%;
  max-height: 100%;
  display: block;
}

@media print {
	/* Ocultar indicador de márgenes en impresión */
	#page-container::after {
		display: none !important;
	}
	
	#pageHeader{ position: running(pageHeader); height: auto; padding-top: 0.5cm;}
	#pageFooter{ position: running(pageFooter); width:auto; padding:0;background:none;box-shadow:none;}
	#pageFooter.no-footer{display:block;}
	.noPDF{display:none;}
	#pageFooter:before, #pageFooter:after{ display:block;}
	#header-container {background: none; position: absolute; top:0;}
	#page-container {top: 0;background: none !important; padding:0 !important; position: absolute;}
	.encabezado-ENAC .fs7.num-cenac {bottom:11pt;}
	.cod-expediente span.code {width: 120pt;}
	.pf{background:none !important;width:18cm; min-height:0; height:auto; margin: 0 auto;top:0;padding: 0;}
	.hf{background:none !important;}
    div.cuerpo {margin: 0;}
	.titulo {margin-bottom: 1em;}
	p{padding-left:0;margin-left:0}
	.medium-editor-table td.without-border {border: 0 !important;}
	.medium-editor-table td.with-border {border: 1px solid black !important;}
	.firma{border:0}
	.salto-pagina{
		visibility: hidden;
        clear: both;
        page-break-after: always;
    }
	caracteristica span {
        page-break-inside: auto;
    }
    caracteristica div.linea {
        page-break-inside: avoid;
		top: 0 !important;
    }
	.ocultar {
		display: none !important;
	}
}
.col2tac .medium-editor-table tr td:nth-child(2){
    text-align:center;
}


</style>
</head>`,

headOferta: `<head>
    <meta content="text/html;charset=utf-8" http-equiv="content-type" />
    <title>MODELO DE OFERTA CORTA V3</title>
    <meta content="nombre largo" name="Oferta modelo resumido V3" />
    <meta content="estado" name="PRELIMINAR" />
    <meta content="autor" name="JAC" />

    <style type="text/css">
        @charset "UTF-8";
        @page {
            /* portrait|landscape */
            size: A4 portrait;
            /* set page margins superior derecho inferior izquierdo*/
            margin: 3.5cm 0cm 1.3cm 0cm;
            @top-center {
                content: element( pageHeader);
            }
            /* @footnote {
                float: bottom;
            } */
            @bottom-left {
                content: counter(page);
                /* " de " counter(pages);*/
                font-size: 20pt;
                padding-left: 10pt;
                /*font-family: sans-serif;*/
                margin-left: 0.8cm;
                color: rgb(35, 53, 91);
            }
            @bottom-center {
                content: "De Conformidad con el Art. 7 del Reglamento (UE) 2016/679  de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos. Vd. Puede ejercer sus derechos de acceso, rectificación, cancelación y oposición de sus datos de carácter personal, enviando una comunicación a la dirección de correo electrónico simecal@simecal.com o bien dirigiendo una solicitud escrita a C/ Manuel Azaña, 39 bajo 47014 Valladolid, acompañando fotocopia de D.N.I.";
                font-size: 6pt;
                font-family: sans-serif;
                color: gray;
            }
            @left-middle {
                content: "......";
                color: white;
                background: white url('templates/OFERTAS/static/CIFVertical.png') no-repeat center right;
                background-size: 0.4cm auto;
            }
        }
        
        .ql-indent-1 {
            padding-left: 3em;
        }
        
        .ql-indent-2 {
            padding-left: 6em;
        }
        
        .ql-indent-3 {
            padding-left: 9em;
        }
        
        .ql-indent-4 {
            padding-left: 12em;
        }
        
        .ql-indent-5 {
            padding-left: 15em;
        }
        
        .ql-indent-6 {
            padding-left: 18em;
        }
        
        .ql-indent-7 {
            padding-left: 21em;
        }
        
        .ql-indent-8 {
            padding-left: 24em;
        }
        
        .ql-size-small {
            font-size: 0.75em;
        }
        
        .ql-size-large {
            font-size: 1.5em;
        }
        
        .ql-size-huge {
            font-size: 2.5em;
        }
        
        body {
            margin: 0;
            font-size: 100%;
            font-family: sans-serif;
            letter-spacing: -0.3pt;
            -webkit-print-color-adjust: exact;
        }
        
        p {
            margin: 0;
        }
        
        .medium-editor-container {
            font-size: 0.8rem;
        }
        #editor-container {
            padding-top: 1.5cm;
        }
        /* #pageHeader {
            height: 3.4cm;
            padding: 0cm 0cm 0 0cm;
        } */
        #pageHeader{ padding-top: 1.5cm; width:100%; position:relative; }

        #pageFooter:before {
            content: "Pag. " counter(page) " de " counter(pages);
            position: absolute;
            bottom: 0.5cm;
            left: 0;
            font-size: 8px;
        }
        #pageFooter:after {
            content: /*INICIO-NOMBRE-FICHERO*/"F.CYL.02.07.PI-AE.10"/*FIN-NOMBRE-FICHERO*/;
            position: absolute;
            bottom: 0.5cm;
            right: 0;
            font-size: 8px;
        }
        #pageFooter:before, #pageFooter:after{ display:none;}
        #pageFooter.no-footer{
            display:none;
        }
        
        #header-container {
            width: auto;
            height: auto;
            overflow: visible;
            background-color: #525659;
            position: relative;
            margin: 0;
	        padding: 1.5cm 0 0;
            border: 0;
            font-family: sans-serif;
            letter-spacing: -0.6px;
        }
        #header-container.no-header {
        display:none;
        }
        
        /* .hf {
            position: relative;
            overflow: hidden;
            border: 0;
            page-break-after: always;
            page-break-inside: avoid;
            margin: 1.5cm auto 0 auto;
            height: 3.4cm;
            background-color: white;
            box-shadow: 1pt 1pt 3pt 0pt #333;
            border-collapse: collapse;
            width: 21cm;
        } */
        .hf {
            position: relative;
            background-color: white;
            overflow: hidden;
            border: 0;
            margin: 0 auto;
            padding: 0 auto; 
            box-shadow: 1px 1px 3px 1px #333;
            border-collapse: collapse;
            width:21.1cm;
        }
        
        #page-container {
            width: auto;
            height: auto;
            top: 4.55cm;
            right: 0;
            left: 0;
            overflow: visible;
            margin: 1mm 0;
            padding: 0;
            border: 0;
            font-family: sans-serif;
            letter-spacing: -0.6px;
        }
        
        .pf {
            position: relative;
            border: 0;
            page-break-after: always;
            page-break-inside: avoid;
            margin: 0 auto;
            box-shadow: 1px 1px 3px 1px #333;
            border-collapse: collapse;
            width: 21cm;
            height: 26.6cm;
        }
        
        p.texto-cabecera {
            color: black;
            font-weight: bold;
            text-align: center;
            font-size: 10pt;
        }
        
        div.page-oferta {
            margin: 0 7mm 8mm 7mm;
        }
        
        div.page2 {
            margin: 0 8mm 15mm 8mm;
        }
        
        div.bloque, div.bloque-servicios {
            border-left: solid #387026 1.5pt;
            background-repeat: repeat-y;
            margin-top: 5pt;
            padding-left: 10pt;
        }
        
        div.bloque.bloque1, div.bloque-servicios.bloque1 {
            margin-top: -2pt;
        }
        
        div.bloque.otrosBloques, div.bloque-servicios.otrosBloques {
            margin-top: 5pt;
        }
		
        
        span.nota_al_pie {
            float: footnote;
        }
        
        table.cell-border-05 {
            border-collapse: collapse;
            margin: 3pt;
        }
        
        table.borer-gray {
            border-color: gray;
        }
        
        table.cell-border-05 td,
        table.cell-border-05 th,
        td.cell-border-05,
        th.cell-border-05 {
            border: 0.5pt solid black;
        }
        
        td.cell-border-right-15,
        th.cell-border-right-15 {
            border-right: 1.5pt;
        }
        
        th.cell-border-05 {
            text-align: center;
            font-weight: bold;
        }
        
        .right {
            text-align: right;
        }
        
        .left {
            text-align: left;
        }
        
        .border-0 {
            border: 0;
        }
        
        .titulo1 {
            color: #1f3864;
            font-family: TimesNewRoman;
            font-size: 10pt;
            font-style: italic;
            font-weight: bold;
            text-transform: uppercase;
        }
        
        .timesNewRoman {
            font-family: TimesNewRoman;
        }
        
        div.titulo1.subtitulo {
            margin-top: 5pt;
        }
        
        .titulo2 {
            color: #385f0b;
            font-family: Calibri;
            font-size: 9pt;
            font-weight: bold;
        }
        
        div.lineaverde {
            color: #387035;
            font-family: TimesNewRoman;
            font-size: 9.5pt;
            font-style: italic;
            font-weight: bold;
            border-bottom: solid #A5C249 0.5pt;
            display: inline;
            left: -10pt;
            padding-left: 11pt;
            position: relative;
            letter-spacing: 0.1pt;
        }
        
        img.lineaverde {
            position: relative;
            top: 16pt;
            left: -25pt;
        }
        
        div.doscolumnas {
            width: 49.6%;
            display: table-cell;
            text-align: justify;
        }
        
        .justify {
            text-align: justify;
        }
        
        div.doscolumnas p,
        div.doscolumnas ol,
        div.doscolumnas ol li {
            margin-block-start: 0;
            margin-block-end: 0;
            padding-inline-start: 0pt;
        }
        
        div.sinespacios p {
            margin-block-start: 0;
            margin-block-end: 0;
            padding-inline-start: 0pt;
            padding-inline-end: 0pt;
            margin: 0;
            padding: 0;
        }
        
        div.sinespacios {
            margin: 0;
            padding: 0;
        }
        
        .calibri {
            font-family: Calibri;
        }
        
        .bold {
            font-weight: bold;
        }
        
        .pd1 {
            padding: 1pt;
        }
        
        .pd2 {
            padding: 2pt;
        }
        
        .pd3 {
            padding: 3pt;
        }
        
        .pd4 {
            padding: 4pt;
        }
        
        .pd5 {
            padding: 5pt;
        }
        
        .pd6 {
            padding: 6pt;
        }
        
        .pd7 {
            padding: 7pt;
        }
        
        .pd8 {
            padding: 8pt;
        }
        
        .pd9 {
            padding: 9pt;
        }
        
        .letsp-02 {
            letter-spacing: -0.2pt;
        }
        
        .letsp-01 {
            letter-spacing: -0.1pt;
        }
        
        .center {
            text-align: center;
        }
        
        .fs12pt {
            font-size: 12pt;
        }
        
        .fs11pt {
            font-size: 11pt;
        }
        
        .fs10pt {
            font-size: 10pt;
        }
        
        .fs9pt {
            font-size: 9pt;
        }
        
        .fs8pt {
            font-size: 8pt;
        }
        
        .fs85pt {
            font-size: 8.5pt;
        }
        
        .fs7pt {
            font-size: 7pt;
        }
        
        .fs6pt {
            font-size: 6pt;
        }
        
        .fs5pt {
            font-size: 4.6pt;
        }
        /* 		ol {list-style: none; } */
        
        ol {
            list-style: none;
            padding-inline-start: 0px;
            list-style: none;
        }
        
        p.html ol,
        p.html p {
            margin-block-start: 0;
            margin-block-end: 0;
        }
        
        .firmacliente {
            /* border: solid 1pt; */
        }
        
        ol.dl {
            list-style-type: lower-latin;
        }
        
        ol.dn {
            list-style-type: decimal;
        }
        
        ol.dr {
            list-style-type: lower-roman;
        }
        
        ol.il {
            list-style-position: inside;
            list-style-type: lower-latin;
        }
        
        ol.in {
            list-style-position: inside;
            list-style-type: decimal;
        }
        
        ol.ir {
            list-style-position: inside;
            list-style-type: lower-roman;
        }
        
        .nota_al_pie {
            float: footnote;
        }
        
        span.resaltado {
            margin-left: -5pt;
            position: relative;
            float: left;
        }
        
        div.campo-iban {
            border: 0.5pt solid black;
            width: 50%;
            vertical-align: middle;
        }
        
        div.etiqueta {
            background-color: gray;
            color: white;
            display: inline-block;
            width: 30pt;
            padding: 4px;
            text-align: center;
        }
        
        div.valor {
            font-stretch: ultra-expanded;
            display: inline-block;
            padding: 0 3px;
        }
        
        .iban {
            letter-spacing: 4px;
            font-family: monospace;
            font-size: 9pt;
        }
        
        span.black-diamond {
            content: "\\2756";
        }
        
        @media print {
            #pageHeader {position: running(pageHeader);height: auto;padding: 0;}
            #header-container {background: none !important;position: absolute;top:0;}
            #page-container   {background: none !important;position: absolute;top:0; padding:0 !important; }
			.noPDF{display:none;}
            .pf,.hf {background:none !important;width:21cm; min-height:0; height:auto; margin: 0 auto;top:0;padding: 0;}
            div.cuerpo {margin: 0;}
            .titulo {margin-bottom: 1em;}
            p{padding-left:0;margin-left:0}
            .medium-editor-table td.without-border {border: 0 !important;}
            .medium-editor-table td.with-border {border: 1px solid black !important;}
            .firma{border:0}
            .salto-pagina{visibility: hidden;clear: both;page-break-after: always;}
            .bloque {page-break-inside: avoid;}
			.bloque-servicios {page-break-inside: auto;orphans : 5;widows : 10;}
        }

        span.black-diamond {
            content: "\\2756";
        }
    </style>
</head>`,
headOtros: `<head>
    <meta content="text/html;charset=utf-8" http-equiv="content-type" />
    <title>plantilla OTROS</title>

    <style type="text/css">
        @charset "UTF-8";
		body { margin:0; font-size:100%; -webkit-print-color-adjust:exact; }
		.header-container {display:none;}
		.editor .pf {border:2px dashed #000; margin:0 auto; width:21cm; min-height:29.7cm; padding:0;}
    </style>
</head>`,
header: '',
footer: '',
name: '',
body: `<body>
	<div id="header-container" class="header-container no-header">
		<div class="hf"><header id="pageHeader" class="header-content">\${header}</header></div>
	</div>
	<div id="page-container">
		<div class="pf">\${content}</div>
	</div>
	<div id="pageFooter" class="footer-content">\${footer}</div>
</body>`,
	  actualContent: '<p>placeholder</p>',
      options: {
		spellcheck: false,
        placeholder: {
            /* This example includes the default options for placeholder,
              if nothing is passed this is what it used */
            text: 'Comience a escribir aquí',
            hideOnClick: true
        },
		disableReturn: true,
        buttonLabels: 'fontawesome',
        toolbar: {
          static: true,
          align: 'center',
          sticky: true,
          updateOnEmptySelection: true,
          buttons: [
            "image","bold", "italic", "underline", "strikethrough", "subscript", "superscript", 
            "anchor", "quote", "pre", "orderedlist", "unorderedlist", 
            "justifyLeft", "justifyCenter", "justifyRight", "justifyFull", "saltoPagina", "mediumEditorEnhacedTable",
			"html", "removeFormat", "fontsize2", "fontname", "colorpicker",
			"watermark", "provisional", "caracteristica", "caracteristicaListado", "valor", "checkbox", "cabecera", "pie", "bloque1"
		  ],
		  onChange: function() { console.log('Cambió: ' + this.content) },
		  onShowToolbar: function() { console.log('handleShowToolbar') }
        }
      },
	  contextMenu_options: [
		{ name: 'Duplicar', slug: 'duplicate', icon: 'fa fa-copy' },
        // { type: 'divider', },
        { name: 'Editar', slug: 'edit',  icon: 'fa-pen-to-square'},
        { name: '<span style="color:red;">Borrar</span>', slug: 'delete', icon: 'fa fa-trash', },
		{ type: 'divider', },
        { name: '<span style="color:blue;">Copiar</span>', slug: 'copy', icon: 'fa fa-trash', },
        { name: '<span style="color:blue;">Pegar</span>', slug: 'paste', icon: 'fa fa-trash', },
		{ type: 'divider', },
		{ name: 'Cancelar', slug: 'cancel', icon: 'fa fa-times', },
	  ],
	  // Guardar menú original para poder restaurarlo
	  originalContextMenu_options: [],
	  marginMenu_options: [
		{ name: '📐 Configurar márgenes', slug: 'configure-margins', icon: 'fa fa-ruler' },
		{ type: 'divider', },
		{ name: '⬆️ Superior: 4.5cm', slug: 'margin-top', icon: 'fa fa-arrow-up' },
		{ name: '➡️ Derecho: 1.5cm', slug: 'margin-right', icon: 'fa fa-arrow-right' },
		{ name: '⬇️ Inferior: 1.5cm', slug: 'margin-bottom', icon: 'fa fa-arrow-down' },
		{ name: '⬅️ Izquierdo: 1.5cm', slug: 'margin-left', icon: 'fa fa-arrow-left' },
		{ type: 'divider', },
		{ name: '🔄 Restablecer por defecto', slug: 'reset-margins', icon: 'fa fa-refresh' },
		{ name: 'Cancelar', slug: 'cancel', icon: 'fa fa-times' },
	  ],
	  objetoActual: {},
	  opciones: false,
	  popupEdicionShow: false,
	  customToolbar: [
        // [{ 'font': [] }],
        [{ 'header': [false, 1, 2, 3, 4, 5, 6, ] }],
        [{ 'size': ['10px', false, '18px', '32px'] }],
		[{ 'font': [] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
        ['blockquote', 'code-block'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'color': [] }, { 'background': [] }],
        ['link', 'image'],
        [{ 'direction': 'rtl' }],
        ['clean'],
		['video']
      ],
    };
  },
  computed: {
	processedContent: function(){
		var self = this;
		if(self.tipo == "templates/EXPEDIENTES/"){
			var body = self.body.replace("${header}",self.header).replace("${content}", self.actualContent).replace("${footer}", self.footer);
			var result = self.htmlData.replace("${head}", self.head).replace("${body}", body)
					.replace(/\/\*INICIO-NOMBRE-FICHERO\*\/.*\/\*FIN-NOMBRE-FICHERO\*\//, `/*INICIO-NOMBRE-FICHERO*/"${self.name}"/*FIN-NOMBRE-FICHERO*/`)
					.replace(/<title>.*<\/title>/, `<title>${self.name}</title>`);
			self.options.paste = {
				/* This example includes the default options for paste,
				if nothing is passed this is what it used */
				forcePlainText: false,
				cleanPastedHTML: false,
				cleanReplacements: [],
				cleanAttrs: ['class', 'style', 'dir'],
				cleanTags: ['meta'],
				unwrapTags: []
			}
			return result;
		} else if(self.tipo == "templates/OFERTAS/"){
			var body = self.body.replace("${header}",self.header).replace("${content}", self.actualContent).replace("${footer}", self.footer);
			var result = self.htmlData.replace("${head}", self.headOferta).replace("${body}", body)
					.replace(/\/\*INICIO-NOMBRE-FICHERO\*\/.*\/\*FIN-NOMBRE-FICHERO\*\//, `/*INICIO-NOMBRE-FICHERO*/"${self.name}"/*FIN-NOMBRE-FICHERO*/`)
					.replace(/<title>.*<\/title>/, `<title>${self.name}</title>`);
			self.options.paste = {
				/* This example includes the default options for paste,
				if nothing is passed this is what it used */
				forcePlainText: false,
				cleanPastedHTML: false,
				cleanReplacements: [],
				cleanAttrs: ['class', 'style', 'dir'],
				cleanTags: ['meta'],
				unwrapTags: []
			}
			return result;
		} else if(self.tipo == "templates/mail/"){
			var body = self.body.replace("${header}",self.header).replace("${content}", self.actualContent).replace("${footer}", self.footer);
			var result = self.htmlData.replace("${head}", self.headMail).replace("${body}", body)
					.replace(/\/\*INICIO-NOMBRE-FICHERO\*\/.*\/\*FIN-NOMBRE-FICHERO\*\//, `/*INICIO-NOMBRE-FICHERO*/"${self.name}"/*FIN-NOMBRE-FICHERO*/`)
					.replace(/<title>.*<\/title>/, `<title>${self.name}</title>`);
			self.options.paste = {
				/* This example includes the default options for paste,
				if nothing is passed this is what it used */
				forcePlainText: false,
				cleanPastedHTML: false,
				cleanReplacements: [],
				cleanAttrs: ['class', 'style', 'dir'],
				cleanTags: ['meta'],
				unwrapTags: []
			}
			return result;
		} else {
			var body = self.body.replace("${header}",self.header).replace("${content}", self.actualContent).replace("${footer}", self.footer);
			var result = self.htmlData.replace("${head}", self.headOtros).replace("${body}", body)
					.replace(/\/\*INICIO-NOMBRE-FICHERO\*\/.*\/\*FIN-NOMBRE-FICHERO\*\//, `/*INICIO-NOMBRE-FICHERO*/"${self.name}"/*FIN-NOMBRE-FICHERO*/`)
					.replace(/<title>.*<\/title>/, `<title>${self.name}</title>`);
			self.options.paste = {
				/* This example includes the default options for paste,
				if nothing is passed this is what it used */
				forcePlainText: false,
				cleanPastedHTML: false,
				cleanReplacements: [],
				cleanAttrs: ['class', 'style', 'dir'],
				cleanTags: ['meta'],
				unwrapTags: []
			}
			return result;
		}
	}
  },
  props: {
    defaultData: {
      type: Object,
      default: null
    },
    data: {
      type: Object,
      default: {}
    },
    tipo: {
      type: String
    }
  },
  methods: {
	// Función que se ejecuta cuando cambia el contenido del editor
	changed() {
		// Sincronizar márgenes del template-config con el CSS cuando hay cambios
		this.$nextTick(() => {
			const configLoaded = this.loadConfigurationFromTemplate();
			if (configLoaded) {
				console.log('Contenido cambiado - sincronizando márgenes desde template-config');
				this.updateCSSFromConfig();
				this.updateMarginMenuOptions();
			}
		});
	},

	handleClick (event) {
		// detenemos la primera acción del evento
		event.preventDefault();
		// ponemos como item el html sobre el que hemos hecho click
		this.item = event.target;
		this.actualSelection = this.getCurrentSelection();
		
		// Restaurar el menú original si estaba usando el menú de márgenes
		if (this.originalContextMenu_options.length > 0) {
			this.contextMenu_options = [...this.originalContextMenu_options];
			this.originalContextMenu_options = [];
		}
		
		console.log('handleClick', event, this.item);
		this.$refs.vueSimpleContextMenu.showMenu(event);
	},


	optionClicked (event) {
		// window.alert(JSON.stringify(event));
		
		// Verificar si es una acción de márgenes (this.item será null)
		const marginActions = ['configure-margins', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'reset-margins', 'cancel'];
		if (marginActions.includes(event.option.slug)) {
			// Manejar acciones de márgenes
			this.handleMarginAction(event.option.slug);
			return;
		}
		
		// Para acciones normales de elementos, verificar que this.item existe
		if (!this.item) {
			console.warn('No hay elemento seleccionado para la acción:', event.option.slug);
			return;
		}
		
		// pintamos el html del elemento sobre el que hemos hecho click
		let objeto = {
			html:this.item.innerHTML,
			tag:this.item.tagName,
			selection: this.actualSelection
		};
		// aplicamos la acción correspondiente, según el evento y el tag del elemento;
		switch (event.option.slug) {
			case 'duplicate':
				// Afecta al tag completo
				this.duplicate(objeto);
				break;
			case 'edit':
				// afecta a la selección, a no ser que no se haya seleccionado nada, que afectará al tag completo
				this.edit(objeto);
				break;
			case 'delete':
				// afecta al tag completo
				this.delete(objeto);
				break;
			case 'copy':
				// afecta al tag completo
				this.copy(objeto);
				break;
			case 'paste':
				// afecta al tag completo
				this.paste(objeto);
				break;
			case 'cancel':
				this.cancel(objeto);
				break;
			default:
				break;
		}

	},

	duplicate(objeto){
		// duplicamos el elemento this.item
		let nuevo = this.item.cloneNode(true);
		// lo insertamos después del elemento this.item
		this.item.parentNode.insertBefore(nuevo, this.item.nextSibling);
	},
	delete(objeto) {
		const self = this;
		const app = self.$f7;
		// borramos el elemento this.item
		// - lanzamos un diálogo de confirmación
		self.$f7.dialog.confirm('¿Está seguro de que desea borrar el elemento seleccionado?', 'Borrar', () => {
			// - si confirma, borramos el elemento
			this.item.parentNode.removeChild(this.item);
		});
	},
	copy(objeto) {
		const self = this;
		const app = self.$f7;
		// copiamos al portapapeles el elemento seleccionado 
		var data = [new ClipboardItem({ "text/html": Promise.resolve(new Blob([objeto.selection], { type: "text/html" })) })];
		navigator.clipboard.write(data).then(function() {
			app.dialog.alert('Copiado al portapapeles');
		}).catch(function(error) {
			app.dialog.alert('Error al copiar al portapapeles: ' + error);
		});
	},
	async paste(objeto) {
		const self = this;
		const app = self.$f7;
		const items = await navigator.clipboard.read();
		let type = items[0].types[0];
		// si items[0].types contiene 'text/html' es que es un elemento html y pondremos type = 'text/html'
		if(items[0].types.includes('text/html')){
			type = 'text/html';
		}
		const div = document.createElement('div');
		switch (type) {
			case 'text/html':
			case 'text/plain':
				const textBlob = await items[0].getType(type);
				console.log("textBlob", textBlob);
				const text = await (new Response(textBlob)).text();
				div.innerHTML = text;
				break;
			case 'image/png':
			case 'image/jpeg':
				const imageBlob = await items[0].getType(type);
				const img = document.createElement('img');
				img.src = URL.createObjectURL(imageBlob);
				div.appendChild(img);
				break;
			default:
				app.dialog.alert('No se puede pegar este tipo de contenido');
				break;
		}
		this.item.parentNode.insertBefore(div, this.item.nextSibling);
	},
	edit(objeto){
		// si hay selección, la rodeamos de un span con un id único
		if(objeto.selection){
			let id = 'id' + Math.random().toString(36).substr(2, 9);
			let span = document.createElement('span');
			span.id = id;
			span.innerHTML = objeto.selection;
			// reemplazamos la selección por el span
			let range = window.getSelection().getRangeAt(0);
			range.deleteContents();
			range.insertNode(span);
			// Asignamos el nuevo span como this.item
			this.item = span;
		}
		// abrimos un modal con las propiedades que queremos modificar del objeto según el tag
		console.log(JSON.stringify(objeto));
		objeto.properties = {};
		objeto.properties.style = {}; 
		objeto.html = this.item.innerHTML; // Cargar el contenido HTML actual del tag
		//this.item.style?this.item.style.filter(st=>st).map(st=>{opciones:null,valor:st}):{};
		Object.keys(this.item.style).forEach(element => {
			if(this.item.style[element]){
				try{
					this.item.style[element] = this.item.style[element];
					objeto.properties.style[element] = {opciones:null,valor:this.item.style[element],tipo: 'style'};
				}catch(e){console.log(e.message);}
			}
		});
		// vamos a añadir los atributos que tiene el elemento objeto, para poderlos modificar si es necesario
		objeto.properties.attributes = {};
		let attrs = this.item.getAttributeNames();
		attrs.forEach(attr => {
			if(attr != 'style') {
				objeto.properties.attributes[attr] = {opciones:null,valor:this.item.getAttribute(attr),tipo: 'attribute'};
			}
		});

		switch (objeto.tag) {
			case 'IMG':
				// en las imágenes poolríamos cambiar la posición (left, right, text), el ancho, el alto.
				// objeto.properties.style.float = {opciones:['left','right','none'],valor:this.item.style.float,tipo: 'style'};
				// objeto.properties.style.width = {opciones:null,valor:this.item.style.width,tipo: 'style'};
				// objeto.properties.style.height = {opciones:null,valor:this.item.style.height,tipo: 'style'};
				
				objeto.properties.attributes['width'] =  {opciones:null,valor:this.item.getAttribute("width"),tipo: 'attribute'};
				objeto.properties.attributes['height'] =  {opciones:null,valor:this.item.getAttribute("height"),tipo: 'attribute'};
				objeto.properties.attributes['align'] =  {opciones:[{content:'left',name:'Izquierda'},{content:'right',name:'Derecha'}],valor:this.item.getAttribute("align"),tipo: 'attribute'};
				break;
			case 'P':
				// en los párrafos podríamos cambiar el tamaño de la fuente, el color, el tipo de letra, el interlineado, la alineación, el espaciado, el margen, el padding
				objeto.properties.style.fontSize = {opciones:null,valor:this.item.style.fontSize,tipo: 'style'};
				objeto.properties.style.color = {opciones:null,valor:this.item.style.color,tipo: 'style'};
				objeto.properties.style.fontFamily = {opciones:null,valor:this.item.style.fontFamily,tipo: 'style'};
				objeto.properties.style.lineHeight = {opciones:null,valor:this.item.style.lineHeight,tipo: 'style'};
				objeto.properties.style.textAlign = {opciones:[
						{content:'left',name:'Izquierda'},
						{content:'center',name:'Centrado'},
						{content:'right',name:'Derecha'},
						{content:'justify',name:'Justificado'}
					],valor:this.item.style.textAlign,tipo: 'style'};
				objeto.properties.style.letterSpacing = {opciones:null,valor:this.item.style.letterSpacing,tipo: 'style'};
				objeto.properties.style.margin = {opciones:null,valor:this.item.style.margin,tipo: 'style'};
				objeto.properties.style.padding = {opciones:null,valor:this.item.style.padding,tipo: 'style'};
				break;
			case 'SPAN':
				// en los spans podríamos cambiar el tamaño de la fuente, el color, el tipo de letra
				objeto.properties.style.fontSize = {opciones:null,valor:this.item.style.fontSize,tipo: 'style'};
				objeto.properties.style.color = {opciones:null,valor:this.item.style.color,tipo: 'style'};
				objeto.properties.style.fontFamily = {opciones:null,valor:this.item.style.fontFamily,tipo: 'style'};
				break;
			case 'VALOR','DIV':
				// en los spans podríamos cambiar el tamaño de la fuente, el color, el tipo de letra
				objeto.properties.style.fontSize = {opciones:null,valor:this.item.style.fontSize,tipo: 'style'};
				objeto.properties.style.color = {opciones:null,valor:this.item.style.color,tipo: 'style'};
				objeto.properties.style.fontFamily = {opciones:null,valor:this.item.style.fontFamily,tipo: 'style'};
				// si es una lista (this.item.getAttribute("data-type")=='list'), le vamos a permitir que defina las propiedades data-condition y el texto a mostrar con los campos de los objetos de la lista o simplemente [valor] si es una lista de strings
				if(this.item.getAttribute("data-type") == 'list') {
					objeto.properties.attributes['data-type'] =  {opciones:null,valor:this.item.getAttribute("data-type"),tipo: 'attribute'};
					objeto.properties.attributes['data-type-value'] = {opciones:null,valor:this.item.getAttribute("data-type-value"),tipo: 'attribute'};
					objeto.properties.attributes['data-condition'] = {opciones:null,valor:this.item.getAttribute("data-condition"),tipo: 'attribute'};
					objeto.properties.innerHTML = {opciones:[],valor:this.item.innerHTML?this.item.innerHTML:"[value]",tipo: "innerHTML"};
					// si alguno de los campos de la lista son listas, le vamos a permitir que defina las propiedades data-recursive-field
					// esto lo veremos mirando si algún campo dentro de valores de los hijos del data-type-value es una lista
					let valor = this.getValor(this.item.getAttribute("data-type-value"));
					if(valor && valor.children && valor.children.length){
						objeto.properties.attributes['data-recursive-field'] = {
							opciones:valor.children.filter(child => child.tipo == 'list').sort((a,b)=>a.name.localeCompare(b.name)),
							valor:this.item.getAttribute("data-recursive-field"),
							tipo: 'attribute'
						};
						objeto.properties.innerHTML = {
							opciones:valor.children.sort((a,b)=>a.name.localeCompare(b.name)),
							valor:this.item.innerHTML?this.item.innerHTML:"--texto--",
							tipo: "innerHTML"
						};
					}
				} else {
					objeto.properties.innerHTML = {
						opciones:this.opciones?this.opciones.sort((a,b)=>a.name.localeCompare(b.name)):[],
						valor:this.item.innerHTML?this.item.innerHTML:"--texto--",
						tipo: "innerHTML"
					};
				}
				break;
		
			default:
				break;
		}
		this.objetoActual = objeto;
		this.popupEdicionShow = true;
		// Ajustar el textarea después de que el popup se haya renderizado
		this.$nextTick(() => {
			this.autoResizeTextarea();
		});
	},
	cancel(objeto) {
	},

	// Método para ajustar automáticamente la altura del textarea
	autoResizeTextarea() {
		const textarea = document.querySelector('.html-editor-textarea');
		if (textarea) {
			// Resetear la altura para calcular el scrollHeight correcto
			textarea.style.height = 'auto';
			// Establecer la altura según el contenido
			const newHeight = textarea.scrollHeight;
			// Aplicar la altura, respetando el máximo de 40 líneas
			const maxHeight = parseFloat(window.getComputedStyle(textarea).maxHeight);
			textarea.style.height = Math.min(newHeight, maxHeight) + 'px';
			
			// Agregar listener para redimensionar cuando el usuario escriba
			textarea.removeEventListener('input', this.autoResizeTextarea);
			textarea.addEventListener('input', () => {
				textarea.style.height = 'auto';
				const newHeight = textarea.scrollHeight;
				const maxHeight = parseFloat(window.getComputedStyle(textarea).maxHeight);
				textarea.style.height = Math.min(newHeight, maxHeight) + 'px';
			});
		}
	},

	// Método centralizado para manejar acciones de márgenes
	handleMarginAction(action) {
		switch (action) {
			case 'configure-margins':
				this.configureMargins();
				break;
			case 'margin-top':
				this.changeMargin('top');
				break;
			case 'margin-right':
				this.changeMargin('right');
				break;
			case 'margin-bottom':
				this.changeMargin('bottom');
				break;
			case 'margin-left':
				this.changeMargin('left');
				break;
			case 'reset-margins':
				this.resetMargins();
				break;
			case 'cancel':
				// Simplemente cerrar el menú para las acciones de márgenes
				break;
			default:
				console.warn('Acción de margen no reconocida:', action);
		}
		
		// Restaurar el menú original después de cualquier acción de margen
		if (this.originalContextMenu_options.length > 0) {
			this.contextMenu_options = [...this.originalContextMenu_options];
			this.originalContextMenu_options = [];
		}
	},

	// Métodos para gestión de márgenes
	showMarginContextMenu(event) {
		this.item = null; // No hay elemento específico seleccionado
		// Guardar el menú original si no está guardado
		if (this.originalContextMenu_options.length === 0) {
			this.originalContextMenu_options = [...this.contextMenu_options];
		}
		// Usar el menú contextual existente pero cambiar las opciones
		this.updateMarginMenuOptions();
		this.contextMenu_options = this.marginMenu_options;
		// Activar el menú contextual
		this.$refs.vueSimpleContextMenu.showMenu(event);
	},

	configureMargins() {
		// Mostrar diálogo de configuración completa de márgenes
		this.$f7.dialog.prompt(
			'Configurar márgenes (separados por comas: superior,derecho,inferior,izquierdo)', 
			'Configuración de márgenes', 
			(input) => {
				// Callback de confirmación
				if (input) {
					const margins = input.split(',').map(m => parseFloat(m.trim()));
					if (margins.length === 4 && margins.every(m => !isNaN(m) && m >= 0.5 && m <= 10)) {
						this.pageMargins = {
							top: margins[0],
							right: margins[1],
							bottom: margins[2],
							left: margins[3]
						};
						this.updateMargins();
						this.updateMarginMenuOptions();
					} else {
						this.$f7.dialog.alert('Formato inválido. Use números entre 0.5 y 10 cm separados por comas.');
					}
				}
			},
			() => {
				// Callback de cancelación
				console.log('Configuración de márgenes cancelada');
			},
			`${this.pageMargins.top},${this.pageMargins.right},${this.pageMargins.bottom},${this.pageMargins.left}`
		);
	},

	changeMargin(side) {
		const currentValue = this.pageMargins[side];
		const sideNames = {
			top: 'superior',
			right: 'derecho', 
			bottom: 'inferior',
			left: 'izquierdo'
		};
		
		this.$f7.dialog.prompt(
			`Nuevo valor para margen ${sideNames[side]} (en cm)`, 
			`Cambiar margen ${sideNames[side]}`, 
			(input) => {
				// Callback de confirmación
				if (input) {
					const newValue = parseFloat(input);
					if (!isNaN(newValue) && newValue >= 0.5 && newValue <= 10) {
						console.log(`Cambiando margen ${side} de ${this.pageMargins[side]} a ${newValue}`);
						this.pageMargins[side] = newValue;
						this.updateMargins();
						this.updateMarginMenuOptions();
						console.log('Nuevos valores de pageMargins:', this.pageMargins);
					} else {
						this.$f7.dialog.alert('Valor inválido. Use un número entre 0.5 y 10 cm.');
					}
				}
			},
			() => {
				// Callback de cancelación
				console.log(`Cambio de margen ${sideNames[side]} cancelado`);
			},
			currentValue.toString()
		);
	},

	resetMargins() {
		this.pageMargins = {
			top: 3.5,
			right: 1.5,
			bottom: 1.5,
			left: 1.5
		};
		this.updateMargins();
		this.updateMarginMenuOptions();
		console.log('Márgenes restablecidos a valores por defecto');
	},

	updateMargins() {
		// Actualizar los márgenes CSS usando el método existente
		this._manageMargins();
		// Actualizar también el CSS original del HTML
		this.updateCSSFromConfig();
		// Guardar la configuración en la plantilla
		this.saveConfigurationToTemplate();
		console.log('Márgenes actualizados:', this.pageMargins);
		// Opcional: notificar al componente padre que el contenido ha cambiado
		this.$nextTick(() => {
			if (this.$refs.mediumeditor && this.$refs.mediumeditor.editor) {
				// Trigger un evento de cambio para que se detecte la modificación
				this.$refs.mediumeditor.editor.trigger('editableInput', null, this.$refs.mediumeditor.$el);
			}
		});
	},

	// Métodos de persistencia de configuración
	saveConfigurationToTemplate() {
		// 1. Buscar o crear el elemento de configuración invisible
		const pageContainer = document.getElementById('page-container');
		if (!pageContainer) return;

		let configElement = pageContainer.querySelector('template-config');
		if (!configElement) {
			configElement = document.createElement('template-config');
			configElement.style.display = 'none';
			configElement.setAttribute('data-template-config', 'true');
			pageContainer.appendChild(configElement);
		}

		// 2. Guardar la configuración como atributos de datos
		configElement.setAttribute('data-page-margins', JSON.stringify(this.pageMargins));
		configElement.setAttribute('data-config-version', '1.0');
		
		// 3. Actualizar también el CSS del HTML original para persistencia
		this.updateCSSFromConfig();
		
		console.log('Configuración guardada en plantilla y CSS actualizado:', this.pageMargins);
	},

	loadConfigurationFromTemplate() {
		// Buscar el elemento de configuración en la plantilla
		const pageContainer = document.getElementById('page-container');
		if (!pageContainer) return false;

		const configElement = pageContainer.querySelector('template-config[data-template-config="true"]');
		let configLoaded = false;
		
		if (configElement) {
			try {
				// Cargar configuración de márgenes guardada
				const marginsData = configElement.getAttribute('data-page-margins');
				if (marginsData) {
					const savedMargins = JSON.parse(marginsData);
					// Validar que los datos sean correctos
					if (savedMargins && typeof savedMargins === 'object' && 
					    savedMargins.top && savedMargins.right && savedMargins.bottom && savedMargins.left) {
						this.pageMargins = savedMargins;
						console.log('Configuración cargada desde data-template-config:', this.pageMargins);
						configLoaded = true;
						// Sincronizar el CSS con la configuración guardada
						this.updateCSSFromConfig();
					}
				}
			} catch (error) {
				console.warn('Error al cargar configuración guardada:', error);
			}
		}
		
		// Si no hay configuración guardada, leer desde el CSS de la plantilla
		if (!configLoaded) {
			try {
				const styleElements = document.querySelectorAll('style');
				console.log('Buscando márgenes en', styleElements.length, 'elementos style');
				for (const styleEl of styleElements) {
					const cssText = styleEl.textContent || styleEl.innerText;
					console.log('Contenido CSS:', cssText.substring(0, 500));
					// Regex mejorada para detectar los márgenes
					const marginMatch = cssText.match(/\/\*PAGE-MARGIN-START\*\/margin:\s*([^;]+);\s*\/\*PAGE-MARGIN-END\*\//)
					if (marginMatch) {
						console.log('Match encontrado:', marginMatch[1]);
						const marginValues = marginMatch[1].trim().split(/\s+/);
						console.log('Valores parseados:', marginValues);
						if (marginValues.length === 4) {
							// Parsear los valores (quitando 'cm' al final)
							const margins = marginValues.map(val => parseFloat(val.replace('cm', '')));
							console.log('Márgenes numéricos:', margins);
							if (margins.every(m => !isNaN(m))) {
								this.pageMargins = {
									top: margins[0],
									right: margins[1],
									bottom: margins[2],
									left: margins[3]
								};
								console.log('Márgenes cargados desde CSS de plantilla:', this.pageMargins);
								// Guardar inmediatamente en data-template-config para mantener sincronización
								this.saveConfigurationToTemplate();
								configLoaded = true;
							}
						}
						break;
					} else {
						console.log('No se encontró patrón PAGE-MARGIN en este style');
					}
				}
			} catch (error) {
				console.warn('Error al leer márgenes desde CSS:', error);
			}
		}
		
		return configLoaded;
	},

	// Nueva función para calcular márgenes basándose en las alturas reales
	calculateMarginsFromContainers() {
		const headerContainer = document.getElementById('header-container');
		const footerContainer = document.getElementById('pageFooter');
		
		let headerHeight = 3.5; // valor por defecto
		let footerHeight = 3; // valor por defecto desde pageMargins
		
		if (headerContainer) {
			// Convertir altura del header de px a cm (aproximadamente 37.8px = 1cm)
			const headerPx = headerContainer.offsetHeight;
			headerHeight = Math.max(1, Math.round((headerPx / 37.8) * 10) / 10); // Redondear a 1 decimal
			console.log(`Header height: ${headerPx}px = ${headerHeight}cm`);
		}
		
		// Si tenemos configuración guardada para el footer, usarla
		if (this.pageMargins.bottom && this.pageMargins.bottom > 0) {
			footerHeight = this.pageMargins.bottom;
			console.log(`Usando altura del footer desde configuración: ${footerHeight}cm`);
			
			// Aplicar la altura configurada al footer si existe
			if (footerContainer) {
				const heightPx = footerHeight * 37.8; // Convertir cm a px
				footerContainer.style.minHeight = heightPx + 'px';
				footerContainer.style.height = 'auto'; // Permitir que crezca si es necesario
				console.log(`Footer height aplicada: ${heightPx}px (${footerHeight}cm)`);
			}
		} else if (footerContainer) {
			// Si no hay configuración, leer altura actual del footer
			const footerPx = footerContainer.offsetHeight;
			footerHeight = Math.max(0.5, Math.round((footerPx / 37.8) * 10) / 10); // Redondear a 1 decimal
			console.log(`Footer height desde DOM: ${footerPx}px = ${footerHeight}cm`);
		}
		
		// Actualizar solo márgenes superior e inferior, mantener laterales del usuario
		this.pageMargins.top = headerHeight;
		this.pageMargins.bottom = footerHeight;
		
		console.log('Márgenes calculados desde contenedores:', this.pageMargins);
		return { headerHeight, footerHeight };
	},

	// Nueva función para actualizar CSS desde configuración guardada
	updateCSSFromConfig() {
		try {
			console.log('Actualizando CSS desde configuración:', this.pageMargins);
			const styleElements = document.querySelectorAll('style');
			console.log('Elementos style encontrados:', styleElements.length);
			
			for (const styleEl of styleElements) {
				const cssText = styleEl.textContent || styleEl.innerText;
				if (cssText.includes('PAGE-MARGIN-START')) {
					console.log('Elemento style con PAGE-MARGIN encontrado');
					console.log('CSS antes:', cssText.substring(0, 200));
					
					// SOLO actualizar el CSS del @page, NO añadir márgenes al page-container
					const newCssText = cssText.replace(
						/\/\*PAGE-MARGIN-START\*\/margin:[^;]+;\s*\/\*PAGE-MARGIN-END\*\//,
						`/*PAGE-MARGIN-START*/margin: ${this.pageMargins.top}cm ${this.pageMargins.right}cm ${this.pageMargins.bottom}cm ${this.pageMargins.left}cm;/*PAGE-MARGIN-END*/`
					);
					
					styleEl.textContent = newCssText;
					console.log('CSS después:', newCssText.substring(0, 200));
					console.log('CSS del @page actualizado desde configuración guardada');
					break;
				}
			}
			
			// Aplicar altura configurada al footer
			const footerContainer = document.getElementById('pageFooter');
			if (footerContainer && this.pageMargins.bottom > 0) {
				const heightPx = this.pageMargins.bottom * 37.8; // Convertir cm a px
				footerContainer.style.minHeight = heightPx + 'px';
				footerContainer.style.height = 'auto';
				console.log(`Footer height aplicada desde config: ${heightPx}px (${this.pageMargins.bottom}cm)`);
			}
		} catch (error) {
			console.warn('Error al actualizar CSS desde configuración:', error);
		}
	},



	updateMarginMenuOptions() {
		// Actualizar las opciones del menú de márgenes con los nuevos valores
		this.marginMenu_options = [
			{ name: '📐 Configurar márgenes', slug: 'configure-margins', icon: 'fa fa-ruler' },
			{ type: 'divider' },
			{ name: `⬆️ Superior: ${this.pageMargins.top}cm`, slug: 'margin-top', icon: 'fa fa-arrow-up' },
			{ name: `➡️ Derecho: ${this.pageMargins.right}cm`, slug: 'margin-right', icon: 'fa fa-arrow-right' },
			{ name: `⬇️ Inferior: ${this.pageMargins.bottom}cm`, slug: 'margin-bottom', icon: 'fa fa-arrow-down' },
			{ name: `⬅️ Izquierdo: ${this.pageMargins.left}cm`, slug: 'margin-left', icon: 'fa fa-arrow-left' },
			{ type: 'divider' },
			{ name: '🔄 Restablecer por defecto', slug: 'reset-margins', icon: 'fa fa-refresh' },
			{ name: 'Cancelar', slug: 'cancel', icon: 'fa fa-times' }
		];
	},
	getValor(valor){
		var self = this;
		let valorEntidad = self.$refs.mediumeditor.editor.options.extensions.valor;
		// buscamos el primer valor que tenga el content == valor
		return valorEntidad.valores.find(v => v.content == valor);
	},
	applyChanges: function() {
		// aplicaremos los estilos de objetoActual al item seleccionado
		var self = this;
		var objeto = self.objetoActual;
		var item = self.item;
		if(objeto.properties.style){
			// Iteramos por todos los atributos de objeto.properties.style
			Object.keys(objeto.properties.style).forEach(key => {
				// si el valor del atributo es diferente al valor del atributo del item, lo cambiamos
				if(objeto.properties.style[key] && objeto.properties.style[key].valor != item.style[key]){
					try{item.style[key] = objeto.properties.style[key].valor;}catch(e){console.log(e);}
				}
			});

		}
		// ahora vamos a aplicar los cambios en los atributos del objeto
		if(objeto.properties.attributes){
			// Iteramos por todos los atributos de objeto.properties.attributes
			Object.keys(objeto.properties.attributes).forEach(key => {
				// si el valor del atributo es diferente al valor del atributo del item, lo cambiamos
				if(objeto.properties.attributes[key].valor != item.getAttribute(key)){
					item.setAttribute(key, objeto.properties.attributes[key].valor);
				}
			});
		}
		// ahora vamos a aplicar los cambios en el contenido html del objeto
		if(objeto.properties.innerHTML){
			// si el valor del atributo es diferente al valor del atributo del item, lo cambiamos
			if(objeto.properties.innerHTML.valor != item.innerHTML){
				item.innerHTML = objeto.properties.innerHTML.valor.replaceAll("\n","<br/>");
			}
		}
		// aplicar cambios en el contenido HTML del tag
		if(objeto.html && objeto.html != item.innerHTML){
			item.innerHTML = objeto.html;
		}
		self.$refs.popupEdicion.close();
	},
	addNewStyle: function() {
		// Agregar un nuevo estilo vacío
		const self = this;
		const commonStyles = [
			{ name: 'color', label: 'Color del texto' },
			{ name: 'backgroundColor', label: 'Color de fondo' },
			{ name: 'fontSize', label: 'Tamaño de fuente (ej: 12px, 1em)' },
			{ name: 'fontFamily', label: 'Familia de fuente (ej: Arial, Times New Roman)' },
			{ name: 'fontWeight', label: 'Peso de fuente (normal, bold, 700, etc)' },
			{ name: 'fontStyle', label: 'Estilo de fuente (normal, italic)' },
			{ name: 'textAlign', label: 'Alineación (left, center, right, justify)' },
			{ name: 'textDecoration', label: 'Decoración (none, underline, overline, line-through)' },
			{ name: 'lineHeight', label: 'Altura de línea (ej: 1.5, 20px)' },
			{ name: 'letterSpacing', label: 'Espaciado de letras (ej: 2px)' },
			{ name: 'wordSpacing', label: 'Espaciado de palabras (ej: 5px)' },
			{ name: 'margin', label: 'Margen (ej: 10px, 10px 20px)' },
			{ name: 'marginTop', label: 'Margen superior' },
			{ name: 'marginBottom', label: 'Margen inferior' },
			{ name: 'marginLeft', label: 'Margen izquierdo' },
			{ name: 'marginRight', label: 'Margen derecho' },
			{ name: 'padding', label: 'Relleno (ej: 10px, 10px 20px)' },
			{ name: 'paddingTop', label: 'Relleno superior' },
			{ name: 'paddingBottom', label: 'Relleno inferior' },
			{ name: 'paddingLeft', label: 'Relleno izquierdo' },
			{ name: 'paddingRight', label: 'Relleno derecho' },
			{ name: 'border', label: 'Borde (ej: 1px solid black)' },
			{ name: 'borderWidth', label: 'Ancho del borde (ej: 2px)' },
			{ name: 'borderColor', label: 'Color del borde' },
			{ name: 'borderStyle', label: 'Estilo del borde (solid, dashed, dotted)' },
			{ name: 'borderRadius', label: 'Esquinas redondeadas (ej: 5px)' },
			{ name: 'width', label: 'Ancho (ej: 100%, 200px)' },
			{ name: 'height', label: 'Alto (ej: 100px, 50%)' },
			{ name: 'minWidth', label: 'Ancho mínimo' },
			{ name: 'maxWidth', label: 'Ancho máximo' },
			{ name: 'minHeight', label: 'Alto mínimo' },
			{ name: 'maxHeight', label: 'Alto máximo' },
			{ name: 'display', label: 'Tipo de visualización (block, inline, inline-block, flex, grid)' },
			{ name: 'float', label: 'Flotación (left, right, none)' },
			{ name: 'clear', label: 'Limpieza de flotación (left, right, both)' },
			{ name: 'position', label: 'Posición (static, relative, absolute, fixed)' },
			{ name: 'top', label: 'Posición desde arriba' },
			{ name: 'bottom', label: 'Posición desde abajo' },
			{ name: 'left', label: 'Posición desde la izquierda' },
			{ name: 'right', label: 'Posición desde la derecha' },
			{ name: 'zIndex', label: 'Índice de profundidad (ej: 10, 100)' },
			{ name: 'opacity', label: 'Opacidad (0 a 1, ej: 0.5)' },
			{ name: 'backgroundImage', label: 'Imagen de fondo (url(...))' },
			{ name: 'backgroundSize', label: 'Tamaño de imagen (cover, contain, 100% 100%)' },
			{ name: 'backgroundPosition', label: 'Posición de imagen (center, top, left, etc)' },
			{ name: 'backgroundRepeat', label: 'Repetición (repeat, no-repeat, repeat-x, repeat-y)' },
			{ name: 'transform', label: 'Transformación (rotate, scale, translate, skew)' },
			{ name: 'textShadow', label: 'Sombra de texto (ej: 2px 2px 4px gray)' },
			{ name: 'boxShadow', label: 'Sombra de caja (ej: 0 2px 4px rgba(0,0,0,0.1))' },
			{ name: 'textIndent', label: 'Indentación de texto' },
			{ name: 'whiteSpace', label: 'Espacio en blanco (normal, nowrap, pre, pre-wrap)' },
			{ name: 'overflow', label: 'Desbordamiento (visible, hidden, scroll, auto)' },
			{ name: 'textTransform', label: 'Transformación de texto (uppercase, lowercase, capitalize)' },
			{ name: 'verticalAlign', label: 'Alineación vertical (top, middle, bottom, baseline)' },
			{ name: 'tableLayout', label: 'Diseño de tabla (auto, fixed)' },
			{ name: 'pageBreakInside', label: 'Salto de página dentro (avoid, auto)' },
			{ name: 'pageBreakBefore', label: 'Salto de página antes (always, avoid, auto)' },
			{ name: 'pageBreakAfter', label: 'Salto de página después (always, avoid, auto)' }
		];

		// Filtrar solo los estilos que no están ya siendo usados
		const usedStyles = Object.keys(self.objetoActual.properties.style || {});
		const availableStyles = commonStyles.filter(style => !usedStyles.includes(style.name));

		if (availableStyles.length === 0) {
			alert('Todos los estilos disponibles ya están siendo utilizados');
			return;
		}

		// Crear HTML para el dialogo con lista de estilos
		let optionsHtml = '<div style="display: flex; flex-direction: column; height: 100%; max-height: 500px;">';
		
		// Botón Cancelar en la parte superior
		optionsHtml += '<div style="padding: 10px; border-bottom: 2px solid #333; flex-shrink: 0;"><button id="btnCancelarStyle" style="width: 100%; padding: 10px; background: #f0f0f0; border: 1px solid #999; cursor: pointer; font-weight: bold;">Cancelar</button></div>';
		
		// Lista de estilos scrollable
		optionsHtml += '<div style="flex: 1; overflow-y: auto; padding: 0;">';
		availableStyles.forEach(style => {
			optionsHtml += `<div style="padding: 12px 15px; border-bottom: 1px solid #e0e0e0; cursor: pointer; transition: background-color 0.2s;" class="style-option" data-style="${style.name}">
				<strong style="color: #333;">${style.name}</strong><br/>
				<small style="color: #666; font-size: 11px;">${style.label}</small>
			</div>`;
		});
		optionsHtml += '</div></div>';

		// Mostrar dialog
		const dialog = self.$f7.dialog.create({
			title: 'Seleccionar estilo CSS (' + availableStyles.length + ' disponibles)',
			content: optionsHtml,
			buttons: []
		});

		dialog.open();

		// Esperar a que el DOM esté listo e añadir listeners
		setTimeout(() => {
			// Botón cancelar
			const btnCancelar = document.getElementById('btnCancelarStyle');
			if (btnCancelar) {
				btnCancelar.addEventListener('click', function() {
					dialog.close();
				});
			}

			// Opciones de estilo
			const styleOptions = document.querySelectorAll('.style-option');
			styleOptions.forEach(option => {
				option.addEventListener('click', function() {
					const styleName = this.getAttribute('data-style');
					if (!self.objetoActual.properties.style[styleName]) {
						self.$set(self.objetoActual.properties.style, styleName, {
							opciones: null,
							valor: '',
							tipo: 'style'
						});
						dialog.close();
					} else {
						alert('Este estilo ya existe');
					}
				});

				// Efecto hover
				option.addEventListener('mouseenter', function() {
					this.style.backgroundColor = '#f5f5f5';
				});
				option.addEventListener('mouseleave', function() {
					this.style.backgroundColor = 'transparent';
				});
			});
		}, 100);
	},
	addNewAttribute: function() {
		// Agregar un nuevo atributo vacío
		const self = this;
		const newAttrName = prompt('Nombre del nuevo atributo (ej: data-custom, title, etc):');
		if (newAttrName && newAttrName.trim()) {
			const cleanName = newAttrName.trim();
			// Verificar que no exista ya y que no sea 'style'
			if (!self.objetoActual.properties.attributes[cleanName] && cleanName !== 'style') {
				self.$set(self.objetoActual.properties.attributes, cleanName, {
					opciones: null,
					valor: '',
					tipo: 'attribute'
				});
			} else {
				alert('Este atributo ya existe o no es válido');
			}
		}
	},
	showOptions: function(property, event) {
		const opciones = property.opciones;
		const self = this;
		self.objetoActual.event = event;
		if(opciones && opciones.length) {
			// Crearemos un select en el aire y el valor seleccionado lo pegaremos en el innerHtml del elemento actual.
			self.opciones = opciones;
			self.property = property;
			self.$refs.popover.open(event.target);
		}
	},
	setOptionSelected: function(event) {
		const self = this;
		let valor = event.target.options[event.target.options.selectedIndex].value;
		// seleccionamos de self.opciones la que tiene el valor seleccionado
		let opcion = self.opciones.find(op => op.content == valor);
		if (self.property.tipo == 'innerHTML') {
			let sel = window.getSelection()
			var newDocument = new DOMParser().parseFromString(self.property.valor, 'text/html');
			var range = sel.getRangeAt(0);
			var element = newDocument.createTextNode(`[${valor}${opcion.tipo == 'html' ? ':html' : ''}]`);
			// element.innerHTML = `[${valor}]`;
			range.insertNode(element);

            // Move the caret immediately after the inserted span
            range.setStartAfter(element);
    
            // Ahora añadimos un espacio al final de range para que no se quede pegado al elemento
            const auxElem = newDocument.createTextNode('\u00A0');
            range.insertNode(auxElem);
            // Move the caret immediately after the inserted span
            range.setStartAfter(auxElem);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range)
			// self.property.valor = window.getSelection().baseNode.textContent.substr(0, window.getSelection().focusOffset) + '[' + valor + ']' + window.getSelection().baseNode.textContent.substr(window.getSelection().focusOffset);
		} else {
			self.property.valor = valor;
		}
		self.opciones = false;
		self.$refs.popover.close(self.objetoActual.event.target);
	},

	getCurrentSelection: function() {
        var html = ''
        var sel

        if (typeof window.getSelection != 'undefined') {
        sel = window.getSelection()
        if (sel.rangeCount) {
            var container = document.createElement('div')
            for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                container.appendChild(sel.getRangeAt(i).cloneContents())
            }
            html = container.innerHTML
        }
        } else if (typeof document.selection != 'undefined') {
            if (document.selection.type == 'Text') {
                html = document.selection.createRange().htmlText
            }
        }
        return html
    },

	getContent() {
		const self = this;
		var contenidoRaw = self.$refs.mediumeditor.editor.getContent(),
			watermarked = false,
			provisional = false,
			top = 0,
			bottom = 0;
		if(self.tipo == "templates/EXPEDIENTES/"){
			watermarked = self.$refs.mediumeditor.editor.options.extensions.watermark.isWatermarked();
			provisional = self.$refs.mediumeditor.editor.options.extensions.provisional.isProvisional();
			top = self.$refs.mediumeditor.editor.options.extensions.cabecera.cabeceraSize();
			bottom = self.$refs.mediumeditor.editor.options.extensions.pie.pieSize();
		} else if(self.tipo == "templates/OFERTAS/"){
			// watermarked = self.$refs.mediumeditor.editor.options.extensions.watermark.isWatermarked();
			// provisional = self.$refs.mediumeditor.editor.options.extensions.provisional.isProvisional();
			top = self.$refs.mediumeditor.editor.options.extensions.cabecera.cabeceraSize();
			bottom = self.$refs.mediumeditor.editor.options.extensions.pie.pieSize();
		}
		var doc = new DOMParser().parseFromString(contenidoRaw, 'text/html'),
			xhtmlDoc =  new XMLSerializer().serializeToString(doc); // Se convierte en xhtml
		xhtmlDoc = this._manageBodyClasses(xhtmlDoc, watermarked, provisional);
		xhtmlDoc = this._manageMargins(xhtmlDoc, top, bottom);
		return xhtmlDoc;
	},
	loadContent(newContent) {
		const self = this;
		var newDocument = new DOMParser().parseFromString(newContent, 'text/html');
		var pfs = Array.from(newDocument.getElementsByClassName("pf"));
		if(self.tipo == "templates/EXPEDIENTES/"){
			// Header content
			var pageHeader = newDocument.getElementById("pageHeader");
			if(pageHeader){
				this.header = pageHeader.innerHTML;
			}
			// Footer content
			var pageFooter = newDocument.getElementById("pageFooter");
			if(pageFooter){
				this.footer = pageFooter.innerHTML;
			}
			// Set everything into one pf
			self.actualContent = pfs.reduce((result, current) => current.innerHTML.trim(),"");

			self.$refs.mediumeditor.editor.setContent(self.processedContent, 0);
			self.$refs.mediumeditor.editor.options.extensions.watermark.setInitialContent(newDocument);
			self.$refs.mediumeditor.editor.options.extensions.provisional.setInitialContent(newDocument);
			self.$refs.mediumeditor.editor.options.extensions.pie.setInitialContent(newDocument);
			self.$refs.mediumeditor.editor.options.extensions.cabecera.setInitialContent(newDocument);
			self.$refs.mediumeditor.editor.options.extensions.cabecera.refresh();
			self.$refs.mediumeditor.editor.options.extensions.pie.refresh();
			
			// Cargar configuración de márgenes de la nueva plantilla
			self.$nextTick(() => {
				const configLoaded = self.loadConfigurationFromTemplate();
				if (!configLoaded) {
					self.calculateMarginsFromContainers();
				}
				// Actualizar el menú con los márgenes de la nueva plantilla
				self.updateMarginMenuOptions();
			});
		} else if(self.tipo == "templates/OFERTAS/"){
			// Header content
			var pageHeader = newDocument.getElementById("pageHeader");
			if(pageHeader){
				this.header = pageHeader.innerHTML;
			}
			// Footer content
			var pageFooter = newDocument.getElementById("pageFooter");
			if(pageFooter){
				this.footer = pageFooter.innerHTML;
			}
			// Set everything into one pf
			self.actualContent = pfs.reduce((result, current) => current.innerHTML.trim(),"");

			self.$refs.mediumeditor.editor.setContent(self.processedContent, 0);
			// self.$refs.mediumeditor.editor.options.extensions.watermark.setInitialContent(newDocument);
			// self.$refs.mediumeditor.editor.options.extensions.provisional.setInitialContent(newDocument);
			self.$refs.mediumeditor.editor.options.extensions.pie.setInitialContent(newDocument);
			self.$refs.mediumeditor.editor.options.extensions.cabecera.setInitialContent(newDocument);
			self.$refs.mediumeditor.editor.options.extensions.cabecera.refresh();
			self.$refs.mediumeditor.editor.options.extensions.pie.refresh();
			
			// Cargar configuración de márgenes de la nueva plantilla
			self.$nextTick(() => {
				const configLoaded = self.loadConfigurationFromTemplate();
				if (!configLoaded) {
					self.calculateMarginsFromContainers();
				}
				// Actualizar el menú con los márgenes de la nueva plantilla
				self.updateMarginMenuOptions();
			});
		} else if(self.tipo == "templates/mail/"){
			if(pfs){
				self.actualContent = pfs.reduce((result, current) => current.innerHTML.trim(),"");
			} else {
				self.actualContent = newContent;
			}
			self.$refs.mediumeditor.editor.setContent(self.processedContent, 0);
			
			// Cargar configuración de márgenes de la nueva plantilla
			self.$nextTick(() => {
				const configLoaded = self.loadConfigurationFromTemplate();
				if (!configLoaded) {
					self.calculateMarginsFromContainers();
				}
				// Actualizar el menú con los márgenes de la nueva plantilla
				self.updateMarginMenuOptions();
			});
		} else {
			if(pfs){
				self.actualContent = pfs.reduce((result, current) => current.innerHTML.trim(),"");
			} else {
				self.actualContent = newContent;
			}
			self.$refs.mediumeditor.editor.setContent(self.processedContent, 0);
			
			// Cargar configuración de márgenes de la nueva plantilla
			self.$nextTick(() => {
				const configLoaded = self.loadConfigurationFromTemplate();
				if (!configLoaded) {
					self.calculateMarginsFromContainers();
				}
				// Actualizar el menú con los márgenes de la nueva plantilla
				self.updateMarginMenuOptions();
			});
		}
		self.$refs.mediumeditor.editor.options.extensions.mediumEditorEnhacedTable.refresh();
	},
	setName(name){
		var self = this;
		self.name = name;
	},
	_prepareDefinition(property, parent){
		var self = this;
		var preparedProp = {};
		var propertyData = {};
		if(parent){
			propertyData = Object.assign({},property);
			propertyData.property = (parent.property) ? `${parent.property}.${propertyData.property}` : propertyData.property;
			propertyData.name = (parent.name) ? `${parent.name} - ${propertyData.name}` : propertyData.name;
		}
		if(property.children && property.children.length){
			property.children.forEach(child => {
				preparedProp[child.property] = self._prepareDefinition(child, propertyData);
			});
		} else {
			preparedProp[propertyData.property] = propertyData.name;
		}
		return preparedProp;
	},
	_subscribePaginas(){
		var self = this;
		self.$refs.mediumeditor.editor.subscribe("editableInput", self._gestionaPaginas);
	},
	_unsubscribePaginas(){
		var self = this;
		self.$refs.mediumeditor.editor.unsubscribe("editableInput", self._gestionaPaginas);
	},
	_gestionaPaginas(){
		return; // Se quita la gestión de páginas de momento, porque está dando problemas
		setTimeout(()=>{
			var self = this;
			var nuevasPaginas = self._calcularPaginas();
			self.nPaginas = nuevasPaginas;
			var pageContainer = document.getElementById("page-container");
			var pages = Array.from(pageContainer.childNodes).filter(node => node.nodeName != "#text");
			var page = (pages.length) ? pages[0] : null;
			if(!page) {
				return;
			}
			page.style.height = (23.7 * self.nPaginas) + 'cm';
		},0);
	},
	_calcularPaginas(){
		var page = null;
		var pages = Array.from(document.getElementById("page-container").childNodes).filter(node => node.nodeName != "#text");
		var page = pages[0];
		var content = Array.from(page.childNodes).filter(node => node.nodeName != "#text");
		var ultimo = content.pop();
		var alturaFinal = ultimo.offsetHeight + ultimo.offsetTop;
		const pageHeight = 880;
		var paginas = Math.floor(alturaFinal/pageHeight) + 1;
		return paginas;
	},
	_manageBodyClasses: function(doc, watermarked, provisional){
		var bodyClasses = [];
		if(watermarked){
			bodyClasses.push("watermarked");
		}
		if(provisional){
			bodyClasses.push("provisional");
		}
		var bodyClassesString = bodyClasses.join(" ");
		return bodyClassesString ? doc.replace("<body>", `<body class="${bodyClassesString}">`) : doc;
	},
	_manageMargins: function(doc, top, bottom){
		// Si se pasan parámetros, usarlos (para compatibilidad con exportación)
		if (arguments.length > 0) {
			// MODIFICADO: Siempre usar los valores del template-config si están disponibles
			// Priorizar pageMargins sobre los parámetros del editor
			const finalTop = this.pageMargins?.top || top || 1.5;
			const finalBottom = this.pageMargins?.bottom || bottom || 1.5;
			const finalRight = this.pageMargins?.right || 1.5;
			const finalLeft = this.pageMargins?.left || 1.5;
			
			console.log('_manageMargins exportando con valores:', { top: finalTop, right: finalRight, bottom: finalBottom, left: finalLeft });
			var newDoc = doc.replace(/\/\*PAGE-MARGIN-START\*\/.*\/\*PAGE-MARGIN-END\*\//, `/*PAGE-MARGIN-START*/margin: ${finalTop}cm ${finalRight}cm ${finalBottom}cm ${finalLeft}cm;/*PAGE-MARGIN-END*/`);
			return newDoc;
		}
		
		// Llamada sin parámetros - actualizar CSS en vivo
		const marginRule = `@page { margin: ${this.pageMargins.top}cm ${this.pageMargins.right}cm ${this.pageMargins.bottom}cm ${this.pageMargins.left}cm; }`;
		
		// 1. Actualizar elemento style dinámico
		let marginStyleElement = document.getElementById('dynamic-page-margins');
		if (!marginStyleElement) {
			marginStyleElement = document.createElement('style');
			marginStyleElement.id = 'dynamic-page-margins';
			marginStyleElement.type = 'text/css';
			document.head.appendChild(marginStyleElement);
		}
		
		// 2. Actualizar también el CSS original de la plantilla
		const styleElements = document.querySelectorAll('style');
		for (const styleEl of styleElements) {
			const cssText = styleEl.textContent || styleEl.innerText;
			if (cssText.includes('PAGE-MARGIN-START')) {
				const newCssText = cssText.replace(
					/\/\*PAGE-MARGIN-START\*\/margin:[^;]+;\s*\/\*PAGE-MARGIN-END\*\//,
					`/*PAGE-MARGIN-START*/margin: ${this.pageMargins.top}cm ${this.pageMargins.right}cm ${this.pageMargins.bottom}cm ${this.pageMargins.left}cm;/*PAGE-MARGIN-END*/`
				);
				styleEl.textContent = newCssText;
				console.log('CSS original de plantilla actualizado');
				break;
			}
		}
		
		// 3. Solo actualizar indicador, sin modificar padding de contenido
		const indicatorRule = `
			#page-container::after {
				position: fixed !important;
				top: 33% !important;
				left: 20% !important;
				z-index: 10000 !important;
			}
		`;
		
		marginStyleElement.textContent = marginRule + indicatorRule;
		console.log('Márgenes actualizados en CSS:', marginRule);
	},
    tratarKeyUp: function(event) { 
		const self = this;
        //Si hemos presionado enter y el nodo tiene el atributo "data-disable-return", "disable-return" o "data-disable-return" a true
        let returnType = window.getSelection().baseNode.parentNode.getAttribute('data-return-type');
		if (returnType && returnType == "no-wrap" && (event.keyCode == 13 || event.which == 13)) {
            event.preventDefault();
            let node = MediumEditor.selection.getSelectionStart(self.$refs.mediumeditor.editor.options.ownerDocument);
			let p = self.$refs.mediumeditor.editor.options.ownerDocument.createElement('p');
			p.innerHTML = '<br>';
			node.parentElement.insertBefore(p, node.nextSibling);
			// move the cursor into the new paragraph
			MediumEditor.selection.moveCursor(self.$refs.mediumeditor.editor.options.ownerDocument, p);
			self.$refs.mediumeditor.editor.options.ownerDocument.execCommand('formatBlock', false, 'p');
        } else if (returnType && (event.keyCode == 13 || event.which == 13)) {
            event.preventDefault();
            let selOnKey = window.getSelection();
            let rangeSel = selOnKey.getRangeAt(0);
            var br = document.createElement(returnType);
            rangeSel.insertNode(br);
            rangeSel.setStartAfter(br);
            rangeSel.collapse(true);
            selOnKey.removeAllRanges();
            selOnKey.addRange(rangeSel);
        } else {


			if (event.keyCode == 13 || event.which == 13) {
				let node = MediumEditor.selection.getSelectionStart(self.$refs.mediumeditor.editor.options.ownerDocument);
				let brText = MediumEditor.selection.getCaretOffsets(node).right === 0;
				// let p = self.$refs.mediumeditor.editor.options.ownerDocument.createElement('p');
				// p.innerHTML = '<br>';
				// node.parentElement.insertBefore(p, node.nextSibling);
				// // move the cursor into the new paragraph
				// MediumEditor.selection.moveCursor(self.$refs.mediumeditor.editor.options.ownerDocument, p);
				let selOnKey = window.getSelection();
				let rangeSel = selOnKey.getRangeAt(0);
				var p = document.createElement('p');
				rangeSel.insertNode(p);
				rangeSel.setStartAfter(p);
				let auxElem = null;
				if (brText) {
					// Ahora añadimos un espacio al final de range para que no se quede pegado al elemento
					auxElem = document.createTextNode('\u00A0');
					rangeSel.insertNode(auxElem);
					// Move the caret immediately after the inserted span
					rangeSel.setStartAfter(auxElem);
				}
				rangeSel.collapse(true);
				selOnKey.removeAllRanges();
				selOnKey.addRange(rangeSel);
				self.$refs.mediumeditor.editor.options.ownerDocument.execCommand('formatBlock', false, 'p');
				if (auxElem) {
					document.removeChild(auxElem)
				}
			}
			// self.$refs.mediumeditor.editor.events.triggerCustomEvent('editableKeydownEnter', event, self.$refs.mediumeditor.editor);
			// self.handleKeyup(event);
		}
    },
	handleKeyup: function(event) {
		const self = this;
		const medium = MediumEditor;
        var node = medium.selection.getSelectionStart(self.$refs.mediumeditor.editor.options.ownerDocument),
            tagName;

        if (!node) {
            return;
        }

        // https://github.com/yabwe/medium-editor/issues/994
        // Firefox thrown an error when calling `formatBlock` on an empty editable blockContainer that's not a <div>
        if (medium.util.isMediumEditorElement(node) && node.children.length === 0 && !medium.util.isBlockContainer(node)) {
            self.$refs.mediumeditor.editor.options.ownerDocument.execCommand('formatBlock', false, 'p');
        }

        // https://github.com/yabwe/medium-editor/issues/834
        // https://github.com/yabwe/medium-editor/pull/382
        // Don't call format block if this is a block element (ie h1, figCaption, etc.)
        if (medium.util.isKey(event, medium.util.keyCode.ENTER) &&
            !medium.util.isListItem(node) &&
            !medium.util.isBlockContainer(node)) {

            tagName = node.nodeName.toLowerCase();
            // For anchor tags, unlink
            if (tagName === 'a') {
                self.$refs.mediumeditor.editor.options.ownerDocument.execCommand('unlink', false, null);
            } else if (!event.shiftKey && !event.ctrlKey) {
                self.$refs.mediumeditor.editor.options.ownerDocument.execCommand('formatBlock', false, 'p');
            }
        } 
    }
  },
  created: function() {
	const self = this;
	let options = {
		'checkbox': new Checkbox(),
		'fontsize2': new FontSize2(),
		'colorpicker': new ColorPicker(),
		'mediumEditorEnhacedTable': new MediumEditorEnhacedTable()
	};
	if(self.tipo == "templates/EXPEDIENTES/"){
		// para los expedientes pondremos que fontsize2 se de modo class
		options.fontsize2.mode = "class";
		options = Object.assign({
			'caracteristica': new Caracteristica(),
			'caracteristicaListado': new CaracteristicaListado(),
			'watermark': new Watermark(),
			'provisional': new Provisional(),
			'cabecera': new Cabecera(),
			'pie': new Pie(),
			'valor': new ValorInspeccion(),
			'saltoPagina': new SaltoPagina(),
			'bloque1': new Bloque({name:'bloque1'}),
			'bloque2': new Bloque({name:'bloque2'})
		}, options);	
	} else if(self.tipo == "templates/OFERTAS/"){
		// para los expedientes pondremos que fontsize2 se de modo class
		options.fontsize2.mode = "class";
		options = Object.assign({
			// 'caracteristica': new Caracteristica(),
			// 'caracteristicaListado': new CaracteristicaListado(),
			// 'watermark': new Watermark(),
			// 'provisional': new Provisional(),
			'cabecera': new Cabecera(),
			'pie': new Pie(),
			'valor': new ValorInspeccion(),
			'saltoPagina': new SaltoPagina(),
			'bloque1': new Bloque({name:'bloque1'}),
			// 'bloque2': new Bloque({name:'bloque2'})
		}, options);	
	} else if(self.tipo == "templates/mail/"){
		// para los mails pondremos que fontsize2 se de modo style
		options.fontsize2.mode = "style";
		options = Object.assign({
			'caracteristica': new Caracteristica({ tipo: self.tipo }),
			'watermark': new Watermark(),
			'provisional': new Provisional(),
			'valor': new ValorEntidad(),
			'saltoPagina': new SaltoPagina(),
			'bloque1': new Bloque({name:'bloque1'})
		}, options);
	}
	self.options.extensions = options;
  },
  mounted: function() {
    const self = this;
	if(self.tipo == "templates/EXPEDIENTES/"){
		Combos.getCombo({filter:{nombre: "bloques1"}}).then(res=>{
			var self = this;
			var bloque1 = self.$refs.mediumeditor.editor.options.extensions.bloque1;
			if (bloque1) {
				bloque1.changeOptions(res.list);
			}
		});
		Combos.getCombo({filter:{nombre: "cabeceras"}}).then(res=>{
			var self = this;
			var cabecera = self.$refs.mediumeditor.editor.options.extensions.cabecera;
			if (cabecera) {
				cabecera.changeOptions(res.list);
			}
		});
		Combos.getCombo({filter:{nombre: "pies"}}).then(res=>{
			var self = this;
			var pie = self.$refs.mediumeditor.editor.options.extensions.pie;
			if (pie) {
				pie.changeOptions(res.list);
			}
		});
		Inspeccion.getDefineCombo({name: "Inspección", property: "inspeccion"}).then(opciones=>{
			var self = this;
			var valor = self.$refs.mediumeditor.editor.options.extensions.valor;
			if (valor) {
				valor.loadValoresInspeccion(opciones);
			}
		});
	} else if(self.tipo == "templates/OFERTAS/"){
		Oferta.getDefineCombo2({name: "Oferta", property: "oferta"}).then(opciones=>{
			var self = this;
			var valor = self.$refs.mediumeditor.editor.options.extensions.valor;
			self.datosCampos = self._prepareDefinition(opciones);
			if (valor) {
				valor.loadValoresEntidad(opciones);
			}
		});
		Combos.getCombo({filter:{nombre: "cabeceras_oferta"}}).then(res=>{
			var self = this;
			var cabecera = self.$refs.mediumeditor.editor.options.extensions.cabecera;
			if (cabecera) {
				cabecera.changeOptions(res.list);
			}
		});
		Combos.getCombo({filter:{nombre: "pies_oferta"}}).then(res=>{
			var self = this;
			var pie = self.$refs.mediumeditor.editor.options.extensions.pie;
			if (pie) {
				pie.changeOptions(res.list);
			}
		});
		Combos.getCombo({filter:{nombre: "bloques_oferta"}}).then(res=>{
			var self = this;
			var bloque1 = self.$refs.mediumeditor.editor.options.extensions.bloque1;
			if (bloque1) {
				bloque1.changeOptions(res.list);
			}
		});
		self.$refs.mediumeditor.editor.on(self.$refs.mediumeditor.$el, "click", (c) => {
			var tableExt = self.$refs.mediumeditor.editor.options.extensions.mediumEditorEnhacedTable;
			tableExt.repositionCursor(c.target);
		});
		
		self._subscribePaginas();
		
		self.$refs.mediumeditor.editor.on(self.$refs.mediumeditor.$el, "keyup", (c) => {
			console.log("keyup");
			self.tratarKeyUp(c);
		});
			
		self.$refs.mediumeditor.editor.on(self.$refs.mediumeditor.$el, "contextmenu", (c) => {
			console.log("contextmenu");
			// Esto lo hago para ignorar la captura del evento contextmenu si se está pulsando la tecla shift
			if (c.shiftKey||c.ctrlKey) {return;}
			self.handleClick(c);
		});
	}else if(self.tipo == "templates/mail/"){
		// si el nombre termina en _oportunidad, usamos el modelo de oportunidades
		let modelo = LineaPedido;
		if(self.data.name.endsWith("_oportunidad")) {
			modelo = Oportunidad;
		} else if(self.data.name.endsWith("_oferta")) {
			modelo = Oferta;
		} else if(self.data.name.endsWith("_tarea")) {
			modelo = Tarea;
		} else if(self.data.name.endsWith("_factura")) {
			modelo = Factura;
		}
		modelo.getDefineCombo2({name: "Línea de pedido", property: "lineaPedido"}).then(opciones=>{
			var self = this;
			var valor = self.$refs.mediumeditor.editor.options.extensions.valor;
			self.datosCampos = self._prepareDefinition(opciones);
			if (valor) {
				valor.loadValoresEntidad(opciones);
			}
		});
		Combos.getCombo({filter:{nombre: "bloques_mail"}}).then(res=>{
			var self = this;
			var bloque1 = self.$refs.mediumeditor.editor.options.extensions.bloque1;
			if (bloque1) {
				bloque1.changeOptions(res.list);
			}
		});
		self.$refs.mediumeditor.editor.on(self.$refs.mediumeditor.$el, "click", (c) => {
			var tableExt = self.$refs.mediumeditor.editor.options.extensions.mediumEditorEnhacedTable;
			tableExt.repositionCursor(c.target);
		});
		
		self._subscribePaginas();
		
		self.$refs.mediumeditor.editor.on(self.$refs.mediumeditor.$el, "keyup", (c) => {
			console.log("keyup");
			self.tratarKeyUp(c);
		});
			
		self.$refs.mediumeditor.editor.on(self.$refs.mediumeditor.$el, "contextmenu", (c) => {
			console.log("contextmenu");
			// Esto lo hago para ignorar la captura del evento contextmenu si se está pulsando la tecla shift
			if (c.shiftKey||c.ctrlKey) {return;}
			self.handleClick(c);
		});
	}
	self.$refs.mediumeditor.editor.on(self.$refs.mediumeditor.$el, "click", (c) => {
		var tableExt = self.$refs.mediumeditor.editor.options.extensions.mediumEditorEnhacedTable;
		tableExt.repositionCursor(c.target);
	});
	
	self._subscribePaginas();
	
	self.$refs.mediumeditor.editor.on(self.$refs.mediumeditor.$el, "keyup", (c) => {
		console.log("keyup");
		self.tratarKeyUp(c);
	});
        
	self.$refs.mediumeditor.editor.on(self.$refs.mediumeditor.$el, "contextmenu", (c) => {
		console.log("contextmenu");
		// Esto lo hago para ignorar la captura del evento contextmenu si se está pulsando la tecla shift
		if (c.shiftKey) {return;}
		self.handleClick(c);
	});

	// Event listeners para las solapas de tabla y fila
	const editorContainer = self.$refs.mediumeditor.$el;
	const pageContainer = document.getElementById('page-container');
	
	// Event listener para detectar clics en el pseudo-elemento ::after
	document.addEventListener('click', (e) => {
		const pageContainer = document.getElementById('page-container');
		if (pageContainer) {
			// Para position: fixed, usar coordenadas de viewport
			const viewportWidth = window.innerWidth;
			const viewportHeight = window.innerHeight;
			
			// Calcular posición del pseudo-elemento (33% top, 20% left)
			const pseudoLeft = viewportWidth * 0.2;
			const pseudoTop = viewportHeight * 0.33;
			const pseudoSize = 40; // 40px de ancho y alto
			
			// Verificar si el click está dentro del área del pseudo-elemento
			if (e.clientX >= pseudoLeft && e.clientX <= (pseudoLeft + pseudoSize) && 
			    e.clientY >= pseudoTop && e.clientY <= (pseudoTop + pseudoSize)) {
				console.log('¡Clic detectado en pseudo-elemento de márgenes!', {
					clickX: e.clientX, 
					clickY: e.clientY, 
					pseudoLeft, 
					pseudoTop
				});
				e.preventDefault();
				e.stopPropagation();
				// Usar bind para asegurar el contexto correcto
				self.showMarginContextMenu.call(self, e);
			}
		}
	});

	// Inicializar el menú de márgenes con valores por defecto
	// La configuración real se cargará cuando se cargue la plantilla en loadContent()
	this.updateMarginMenuOptions();
  }
};
</script>